<template>
  <div
    class="cover flex-col"
    @click="menuList = null"

    style="position: relative"
  >
    <el-collapse-transition>
      <div class="search-box" v-show="isShow" id="canvas">
        <div class="justify-center content">
          <div class="left-input-box">
            <div class="align-center input-select">
              <el-autocomplete
                :placeholder="
                  newParam.searchType == 0
                    ? '请输入关键词进行检索 多个关键词之间用空格隔开'
                    : '请输入关键词进行检索'
                "
                v-model="newParam.keyword"
                class="input-select"
                @click.stop.native
                @keyup.enter.native="clickSearch(true)"
                style="margin-bottom: 0"
                type="search"
                :fetch-suggestions="
                  (queryString, cb) => {
                    getStorages(queryString, cb, 'keyword');
                  }
                "
              >
                <el-select
                  v-model="newParam.searchType"
                  slot="prepend"
                  placeholder="请选择"
                  style="width: 120px"
                  @change="searchTypechan"
                >
                  <el-option label="一般检索" value="0"></el-option>
                  <el-option label="逻辑检索" value="1"></el-option>
                  <el-option label="范围检索" value="2"></el-option>
                  <el-option label="书目检索" value="3"></el-option>
                  <!--                  <el-option label="NEAR檢索" value="2"></el-option>-->
                </el-select>
                <el-select
                  v-if="newParam.searchType === '1'"
                  v-model="newParam.textType"
                  style="width: 80px; margin-left: 20px"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="正文" value="1"></el-option>
                  <el-option label="书名" value="5"></el-option>
                  <el-option label="作者" value="4"></el-option>
                  <el-option label="专名词" value="3"></el-option>
<!--                  <el-option label="注释" value="2"></el-option>-->
                  <el-option label="书名词" value="8"></el-option>
                  <el-option label="地名词" value="9"></el-option>
                </el-select>
                <!-- <img slot="append" class="after" src="/static/icon/data.png" /> -->
              </el-autocomplete>
              <el-button
                slot="append"
                type="primary"
                class="submit-btn"
                :icon="loading ? 'el-icon-loading' : ''"
                round
                @click.stop="clickSearch(true)"
              >
                <img
                  v-if="!loading"
                  style="height: 1rem; width: auto"
                  src="/static/search.png"
                  alt=""
                />
              </el-button>
            </div>
            <div
              style="background-color: rgb(246, 242, 233); width: 600px; padding: 10px;margin-left: 18px;border-radius: 0px 0px 4px 4px;"
              v-if="newParam.searchType != 0 && newParam.searchType != 3"
              ref="popop"
            >
              <template v-if="newParam.searchType === '1'">
                <el-autocomplete
                  v-for="(item, index) in advancedQuery"
                  :key="index + 'ad'"
                  placeholder="请输入关键词进行检索"
                  @click.stop.native
                  v-model="item.keyword"
                  @keyup.enter.native="clickSearch(true)"
                  class="input-select"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      getStorages(queryString, cb, 'advanced' + index);
                    }
                  "
                  style="margin-bottom: 15px"
                >
                  <el-select
                    v-model="item.type"
                    style="width: 120px; margin-right: 20px"
                    slot="prepend"
                    placeholder="请选择"
                  >
                    <el-option label="OR" value="or"></el-option>
                    <el-option label="AND" value="and"></el-option>
                    <el-option label="NOT" value="not"></el-option>
                  </el-select>
                  <el-select
                    v-model="item.textType"
                    style="width: 80px"
                    slot="prepend"
                    placeholder="请选择"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="正文" value="1"></el-option>
                    <el-option label="书名" value="5"></el-option>
                    <el-option label="作者" value="4"></el-option>
<!--                    <el-option label="注释" value="2"></el-option>-->
                    <el-option label="专名词" value="3"></el-option>


                    <!-- <el-option label="篇内容" value="7"></el-option> -->
                    <el-option label="书名词" value="8"></el-option>
                    <el-option label="地名词" value="9"></el-option>
                  </el-select>
                  <!-- <img
                    slot="append"
                    class="after"
                    @click.stop="advancedQuery.splice(index, 1)"
                    src="/static/icon/delete.png"
                  /> -->
                  <!-- <i
                    class="el-icon-delete el-input__icon"
                    slot="suffix"
                    @click.stop="advancedQuery.splice(index, 1)"
                  >
                  </i> -->
                </el-autocomplete>
              </template>

              <template v-if="newParam.searchType === '2'">
                <el-autocomplete
                  v-for="(item, index) in neardQuery"
                  :key="index + 'ne'"
                  placeholder="请输入关键词进行检索"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      getStorages(queryString, cb, 'neard' + index);
                    }
                  "
                  @click.stop.native
                  @keyup.enter.native="clickSearch(true)"
                  v-model="item.keyword"
                  class="input-select input-select-label inputNumber"
                  style="padding-right: 0px; margin-bottom: 15px"
                >
                  <div slot="prepend">
                    NEAR字距
                    <el-select
                      v-model="item.type"
                      v-if="item.type"
                      style="width: 120px; padding: 0 20px"
                      slot="prepend"
                      placeholder="请选择"
                    >
                      <el-option label="OR" value="or"></el-option>
                      <el-option label="AND" value="and"></el-option>
                      <el-option label="NOT" value="not"></el-option>
                    </el-select>
                    <el-input-number
                      class="onlyNumber"
                      v-model="item.spacing"
                      style="width: 100px"
                      @change="contolNumber"
                      :min="1"
                      :max="30"
                      controls-position="right"
                    >
                    </el-input-number>
                  </div>
                </el-autocomplete>
              </template>

              <!-- <template v-if="newParam.searchType === '3'">
                <el-autocomplete
                  v-for="(item, index) in advancedQuery"
                  :key="index + 'ad'"
                  placeholder="請輸入内容"
                  @click.stop.native
                  v-model="item.keyword"
                  @keyup.enter.native="clickSearch(true)"
                  class="input-select"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      getStorages(queryString, cb, 'advanced' + index);
                    }
                  "
                  style="margin-bottom: 15px"
                >
                  <el-select
                    v-model="item.type"
                    style="width: 120px; margin-right: 20px"
                    slot="prepend"
                    placeholder="请选择"
                  >
                    <el-option label="OR" value="or"></el-option>
                    <el-option label="AND" value="and"></el-option>
                    <el-option label="NOT" value="not"></el-option>
                  </el-select>
                  <el-select
                    v-model="item.textType"
                    style="width: 80px"
                    slot="prepend"
                    placeholder="请选择"
                  >
                    <el-option label="正文" value="1"></el-option>
                    <el-option label="校記" value="2"></el-option>
                    <el-option label="專名" value="3"></el-option>
                  </el-select>
                  <img
                    slot="append"
                    class="after"
                    @click.stop="advancedQuery.splice(index, 1)"
                    src="/static/icon/delete.png"
                  />
                </el-autocomplete>
              </template> -->

              <div class="justify-between content">
                <div>
                  <!-- <template v-if="newParam.searchType === '0'">
                    <el-button size="small" @click.stop="clearsearch"
                      >清除關鍵詞
                      <i class="iconfont icon-delete"></i>
                      ></el-button
                    >
                  </template> -->

                  <template v-if="newParam.searchType === '1'">
                    <!-- <el-button
                  size="small"
                  @click.stop="
                    advancedQuery.push({
                      type: 'and',
                      keyword: '',
                    })
                  "
                  >增加條件 <i class="el-icon-plus"></i
                ></el-button> -->
                    <el-button
                      size="small"
                      @click.stop="clearsearch"
                      style="margin-right: 15px"
                      >清除所有关键词
                      <!-- <i class="el-icon-delete"></i> -->
                      <i class="iconfont icon-delete"></i>
                    </el-button>
                    <!-- @click="
                    isSearching = false;

                    advancedQuery = [];
                    search.keyword = '';
                  " -->
                  </template>
                  <template v-if="newParam.searchType === '2'">
                    <el-button
                      size="small"
                      @click.stop="clearsearch"
                      style="margin-right: 15px"
                      >清除条件
                      <!-- <i class="el-icon-delete"></i -->
                      <i class="iconfont icon-delete"></i>
                    </el-button>
                  </template>
                  <!-- <el-checkbox
                    class="checkboxstyle"
                    v-model="searchAccuracyType"
                    >漢字關聯</el-checkbox
                  > -->
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="search-range"> -->
          <!-- <div class="zdbox"> -->
          <!-- <span class="zidingyi" @click="setRangeType(11)"
                >自定義檢索範圍</span
              > -->
          <!-- <el-checkbox v-model="newIsCheck" @change="setRangeType(11)"
                >自定義檢索範圍</el-checkbox
              >
              <div v-show="xdwenxian" class="zdxuanze">
                <span class="kuohao">(</span
                ><span class="xdwenxian"> {{ xdwenxian }} </span
                ><span class="kuohao">)</span>
              </div>
              <div v-show="!xdwenxian" class="weixuanze">
                <span><i>(</i>書名，作者檢索<i>)</i></span>
              </div>
            </div> -->
          <!-- <div class="select-range justify-between">
              <el-checkbox
                :value="rangeType == 1"
                @click.stop.native
                @change="setRangeType(1)"
                >全庫</el-checkbox
              >
              <span>
                <el-checkbox
                  :value="rangeType == 2"
                  @click.stop.native
                  @change="setRangeType(2)"
                  >自定義</el-checkbox
                >

                <i
                  class="iconfont icon-delete"
                  style="font-size: 16px"
                  @click.stop="clearSearchTree"
                ></i>
              </span>
            </div> -->
          <!-- <el-dialog
              :visible.sync="isVisiableCustomRange"
              style="margin-top: 26px"
              :before-close="handleClose"
            >
              <div>
                <span
                  class="btn"
                  :class="customRangeType === 'category' && 'active'"
                  @click.stop="
                    customRangeType = 'category';
                    clearSearchTree();
                  "
                  >部類書名檢索
                </span>
                <span
                  class="btn"
                  :class="customRangeType === 2 && 'active'"
                  @click.stop="
                    customRangeType = 2;
                    clearSearchTree();
                  "
                  >作者檢索
                </span>
              </div>
              <div v-show="customRangeType === 'category'">
                <el-autocomplete
                  size="small"
                  class="marginNew"
                  @input="getCategory()"
                  v-model="search.category"
                  placeholder="請輸入書名"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      getStorages(queryString, cb, 'category');
                    }
                  "
                >

                </el-autocomplete>
                <el-tree
                  v-show="selectTreeIndex === 0"
                  :default-expand-all="isCategorySearch"
                  ref="scopeTreeCat"
                  :key="isCategorySearch ? 'isCategorySearch' : '1'"
                  :data="treeList.category"
                  :props="defaultProps"
                  node-key="key"
                  show-checkbox
                >
                  <span slot-scope="{ node, data }">
                    <span
                      v-if="data"
                      @click="getDetail(node.isLeaf, data)"
                      v-html="
                        isCategorySearch
                          ? hightLighyt(data.name, search.category)
                          : data.name
                      "
                    >
                    </span>
                  </span>
                </el-tree>
              </div>
              <div v-show="customRangeType === 2">
                <div class="margin">
                  <div class="margin-ri">
                    <el-checkbox
                      :value="isAuth == 'pinyin'"
                      @click.stop.native
                      @change="
                        isAuth = 'pinyin';
                        clearSearchTree();
                      "
                      >音序</el-checkbox
                    >
                  </div>
                  <div class="margin-ri">
                    <el-checkbox
                      :value="isAuth == 'dynasty'"
                      @click.stop.native
                      @change="
                        isAuth = 'dynasty';
                        clearSearchTree();
                      "
                      >朝代
                    </el-checkbox>
                  </div>
                </div>
                <el-autocomplete
                  size="small"
                  class="margin"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      getStorages(queryString, cb, 'pinyin');
                    }
                  "
                  v-if="isAuth == 'pinyin'"
                  @input="getPinyin()"
                  v-model="search.pinyin"
                  placeholder="請輸入作者"
                >

                </el-autocomplete>
                <el-autocomplete
                  size="small"
                  class="margin"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      getStorages(queryString, cb, 'dynasty');
                    }
                  "
                  v-if="isAuth == 'dynasty'"
                  @input="getDynasty()"
                  v-model="search.dynasty"
                  placeholder="請輸入作者"
                >

                </el-autocomplete>
                <div v-show="isAuth === 'pinyin'">
                  <el-tree
                    ref="scopeTreeWriter"
                    node-key="key"
                    :default-expand-all="isPinyinSearch"
                    :key="isPinyinSearch ? 'isPinyinSearch' : '1'"
                    :data="treeList.pinyin"
                    :props="defaultProps"
                    show-checkbox
                  >
                    <span slot-scope="{ node, data }">
                      <span
                        v-if="data"
                        @click="getDetail(node.isLeaf, data)"
                        v-html="
                          isPinyinSearch && !node.isLeaf
                            ? hightLighyt(data.name, search.pinyin)
                            : data.name
                        "
                      ></span>
                    </span>
                  </el-tree>
                </div>
                <div v-show="isAuth === 'dynasty'">
                  <el-tree
                    ref="scopeTreeWriterDynasty"
                    node-key="key"
                    :default-expand-all="isDynastySearch"
                    :key="isDynastySearch ? 'isDynastySearch' : '1'"
                    :data="treeList.dynasty"
                    :props="defaultProps"
                    show-checkbox
                  >
                    <span slot-scope="{ node, data }">
                      <span
                        v-if="data"
                        @click="getDetail(node.isLeaf, data)"
                        v-html="
                          isDynastySearch && !node.isLeaf
                            ? hightLighyt(data.name, search.dynasty)
                            : data.name
                        "
                      ></span>
                    </span>
                  </el-tree>
                </div>
              </div>
              <el-divider></el-divider>

              <span class="btn active" @click.stop="setRangeType(2)"
                >確認範圍
              </span>
            </el-dialog> -->
          <!-- </div> -->
        </div>
      </div>
    </el-collapse-transition>
    <div class="topbottom">
      <img
        class="totop"
        v-show="isShow"
        src="/static/icon/top.png"
        alt=""
        @click="changeShow()"
      />
      <img
        class="tobottom"
        v-show="!isShow"
        src="/static/icon/bottom.png"
        alt=""
        @click="changeShow()"
      />
    </div>
    <div class="content-box">
      <div
        class="tree-list heitani"
        ref="leftDragCate"
        :style="{ height: leftHeight + 'vh' }"
      >
        <div
          class="drag-box"
          @mousedown="getClientInfo($event, 'leftDragCate')"
        ></div>
        <!-- 左侧树状结构 -->
        <div class="borderline">
          <div class="borderlinecon"></div>
          <!-- <div class="justify-between align-center simplestyle">
            <span></span>
            <el-button
              size="small"
              :type="isSimple ? 'primary' : ''"
              round
              @click="changePermitTwo(true, '1')"
              >檢索結果目録</el-button
            >
            <el-button
              size="small"
              :type="!isSimple ? 'primary' : ''"
              round
              @click="changePermitTwo(false, 0)"
              >全庫結果分佈</el-button
            >
            <span></span>
          </div> -->
          <div class="treeTittle">
            <div class="tittleName">智能筛选</div>
            <div>
              <el-button
                type="text"
                icon="el-icon-refresh-right"
                @click="leftClearSearch(false, true)"
                style="color: #E9B63E;margin-right: 15px"
              >
                清除选项
              </el-button>
            </div>
          </div>
            <!--             "全結構模式" : "簡潔模式"-->
            <div class="tree">
              <div class="titles">
                <!-- <span>《儒藏》精华篇 </span> -->
                <div>
                  <img src="/static/search/sibu.png" style="width: 18px;height: 16px;margin-right: 10px">
                </div>
                <span>四部分类 </span>
                <!-- <el-input
                  size="mini"
                  placeholder="请输入内容"
                  suffix-icon="el-icon-search"
                  v-model="fenlei"
                  @keyup.enter.native="fenleiSearch()"
                >
                </el-input> -->
                <!-- <i
                  :class="
                    searchTree.tree === 1
                      ? 'el-icon-caret-bottom'
                      : 'el-icon-caret-right'
                  "
                  @click="searchTree.tree = searchTree.tree === 1 ? 0 : 1"
                  class="right-icon"
                ></i> -->
              </div>
              <div class="treeitem">
                <transition name="fade-in">
                  <el-checkbox-group
                    class=" left-width"
                    v-model="searchFilter.categoryNames"
                  >
                    <el-checkbox
                      v-for="item in catalist"
                      :label="item.showName"
                      :key="item.id"
                      :value="item.id"
                      @click.stop.native
                      @change="
                        searchFilter.type = '0';
                        clickSearch(false, true);
                      "
                      style="width: 100%; margin-right: 0; height: 26px"
                    >
                      {{ item.showName }}
                    </el-checkbox>
                  </el-checkbox-group>
                </transition>
              </div>
            </div>
            <!-- <div class="tree zuozhe">
              <div class="justify-between align-center titles">
                <span>作者</span>
                <el-input
                  size="mini"
                  placeholder="请输入内容"
                  suffix-icon="el-icon-search"
                  v-model="zuozhe"
                  @keyup.enter.native="zuozheSearch()"
                >
                </el-input>

              </div>
              <div class="treeitem">
                <el-checkbox-group
                  class="padding-left left-width"
                  v-model="searchFilter.writerIds"
                >
                  <el-checkbox
                    v-for="item in zuozhelist"
                    :label="item.id"
                    :key="item.id"
                    :value="item.id"
                    style="width: 50%; margin-right: 0; height: 26px"
                    >{{ item.showName }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </div> -->
            <div class="tree">
              <div class="titles">
                <div>
                  <img src="/static/search/chaodai.png" style="width: 18px;height: 16px;margin-right: 10px">
                </div>
                <span>朝代</span>
                <!-- <el-input
                  size="mini"
                  placeholder="请输入内容"
                  suffix-icon="el-icon-search"
                  v-model="dynasty"
                  @keyup.enter.native="getDynastyListNew()"
                >
                </el-input> -->
              </div>
              <div class="treeitem">
<!--                <transition name="fade-in">
                  <el-tree
                    :empty-text="emptyText"
                    ref="treeList"
                    v-show="dynastylist"
                    :data="dynastylist"
                    :check-on-click-node="true"
                    :expand-on-click-node="false"
                    :default-checked-keys="searchFilter.dynastyNames"
                    @check="setSearchFilter()"
                    node-key="wholeLabel"
                    show-checkbox
                    style="background-color: none"
                  >
                    <span class="span-ellipsis" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>
                    </span>
                  </el-tree>
                </transition>-->
                <transition name="fade-in">
                  <el-checkbox-group
                    class=" left-width"
                    v-model="searchFilter.dynastyNames"
                    v-show="dynastylist"
                  >
                    <el-checkbox
                      v-for="item in dynastylist"
                      :label="item.label"
                      :key="item.value"
                      :value="item.value"
                      @click.stop.native
                      @change="
                        searchFilter.type = '0';
                        clickSearch(false, true);
                      "
                      style="width: 100%; margin-right: 0; height: 26px"
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </transition>
              </div>
            </div>
            <div class="tree" style="border: none">
              <div class="titles">
                <div>
                  <img src="/static/search/shudan.png" style="width: 18px;height: 16px;margin-right: 10px">
                </div>
                <span>书单</span>
                <!-- <el-input
                  size="mini"
                  placeholder="请输入内容"
                  suffix-icon="el-icon-search"
                  v-model="shudan"
                  @keyup.enter.native="shudanSearch()"
                >
                </el-input> -->
                <!-- <i
                  :class="
                    searchTree.dynasty
                      ? 'el-icon-caret-bottom'
                      : 'el-icon-caret-right'
                  "
                  @click="searchTree.dynasty = searchTree.dynasty === 1 ? 0 : 1"
                  class="right-icon"
                ></i> -->
              </div>
              <div class="treeitem">
                <el-checkbox-group
                  class=" left-width"
                  v-model="searchFilter.bookReadingListIds"
                >
                  <el-checkbox
                    v-for="item in readinglist"
                    :label="item.id"
                    :key="item.id"
                    :value="item.id"
                    @click.stop.native
                    @change="
                      searchFilter.type = '0';
                      clickSearch(false, true);
                    "
                    style="width: 100%; margin-right: 0; height: 26px"
                  >
                    {{ item.showName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>



          <div class="borderlinecon"></div>
        </div>
      </div>
      <!--      <div-->
      <!--        class="tree-list heitani"-->
      <!--        ref="leftDragCate"-->
      <!--        :style="{ height: leftHeight + 'vh', paddingBottom: '1rem' }"-->
      <!--        v-else-->
      <!--      >-->
      <!--        <div-->
      <!--          class="drag-box"-->
      <!--          @mousedown="getClientInfo($event, 'leftDragCate')"-->
      <!--        ></div>-->
      <!--        <div class="borderline">-->
      <!--          <div class="borderlinecon"></div>-->
      <!--          <div class="treescroll">-->
      <!--            <div class="tree" style="borderbottom: none">-->
      <!--              <div class="justify-between align-center titles">-->
      <!--                &lt;!&ndash; <span>《儒藏》精华篇 </span> &ndash;&gt;-->
      <!--                <span>部類 </span>-->
      <!--                <div>-->
      <!--                  <el-button-->
      <!--                    v-show="isShowQuanKu"-->
      <!--                    size="small"-->
      <!--                    :type="!isSimple ? 'primary' : ''"-->
      <!--                    round-->
      <!--                    @click="changePermit"-->
      <!--                    >全庫</el-button-->
      <!--                  >-->
      <!--                  <i-->
      <!--                    :class="-->
      <!--                      searchTree.tree === 1-->
      <!--                        ? 'el-icon-caret-bottom'-->
      <!--                        : 'el-icon-caret-right'-->
      <!--                    "-->
      <!--                    @click="changeTreeIndexSearch()"-->
      <!--                    class="right-icon"-->
      <!--                  ></i>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <transition name="fade-in">-->
      <!--                <el-tree-->
      <!--                  :empty-text="emptyText"-->
      <!--                  :render-content="rendercontent"-->
      <!--                  ref="defaultSearchTree"-->
      <!--                  :default-expand-all="true"-->
      <!--                  :data="searchResult.tree"-->
      <!--                  :props="defaultTreeProps"-->
      <!--                  node-key="id"-->
      <!--                  :check-on-click-node="true"-->
      <!--                  :expand-on-click-node="false"-->
      <!--                  :filter-node-method="getDefaltFilter"-->
      <!--                  @check="getTreeDefaultSearch"-->
      <!--                  @node-click="isornotpermit"-->
      <!--                  show-checkbox-->
      <!--                  :highlight-current="true"-->
      <!--                >-->
      <!--                  &lt;!&ndash; <span class="custom-tree-node" slot-scope="{ node, data }">-->
      <!--                    <span-->
      <!--                      v-if="catalogIdList && catalogIdList.includes(data.id)"-->
      <!--                      >*</span-->
      <!--                    ><span>{{ node.label }}</span>-->
      <!--                  </span> &ndash;&gt;-->
      <!--                </el-tree>-->
      <!--                &lt;!&ndash; :data="treeList.category" &ndash;&gt;-->
      <!--              </transition>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="borderlinecon"></div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div
        class="select-content flex-grow"
        :style="{ height: contHeight + 'vh', overflowY: 'hidden' }"
        v-loading="loading"
      >
        <!-- 结果头部 -->
        <div class="head-condition justify-between">
          <!--          <div class="flex align-center" v-if="searchResult.numArr">-->
          <!--            <span class="label">檢索結果：</span>-->
          <!--            <div class="flex" v-if="isSearching">-->
          <!--              <div-->
          <!--                class="btn"-->
          <!--                v-for="item in searchResult.numArr"-->
          <!--                :class="searchFilter.type === item.type && 'active'"-->
          <!--                @click="typeSearch(item.type)"-->
          <!--                :key="item.name"-->
          <!--              >-->
          <!--                {{ item.name + "（" + (item.value || 0) + "）" }}-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div v-else></div>-->
          <div>
            <div class="restext" v-if="numresult > 0">
              找到
              <span>{{numBookResult}}</span>本书
              <span>{{ numresult }}</span>
              条
              <span v-show="keywordAll">“{{keywordAll }}”</span>
              搜索结果
            </div>
          </div>
          <div class="flex align-center">
            <!-- 全部展开 -->
            <!--            <el-button-->
            <!--              v-if="isSearching"-->
            <!--              @click="dialogTableVisible = true"-->
            <!--              class="btn center"-->
            <!--              id="analyze-cat"-->
            <!--            >-->
            <!--              數據分析-->
            <!--            </el-button>-->
            <!-- <el-dialog
              title="數據分析（全庫結果）"
              v-if="dialogTableVisible"
              :visible.sync="dialogTableVisible"
              top="10vh"
            >
              <Analysis
                :result="searchResult.tree"
                :dlist="searchResult.dynastyList"
              />
            </el-dialog> -->
            <!-- v-if="searchResult.numArr" -->
<!--            <el-button
              v-show="activeName != ''"
              class="btn center"
              @click="viewAllMoreList"
              >{{ changestate }}</el-button
            >-->
            <!--            <el-button-->
            <!--              class="btn center"-->
            <!--              v-if="-->
            <!--                isSearching &&-->
            <!--                searchResult.bookList &&-->
            <!--                searchResult.bookList.length-->
            <!--              "-->
            <!--              @click="downSearch"-->
            <!--              :loading="downLoading"-->
            <!--            >-->
            <!--              導出檢索結果-->
            <!--              <i class="iconfont icon-xiazai"></i>-->
            <!--              &lt;!&ndash; <img src="/static/icon/export.png" /> &ndash;&gt;-->
            <!--            </el-button>-->
            <!-- <el-select
              style="width: 80px"
              size="small"
              v-if="
                isSearching &&
                searchResult.bookList &&
                searchResult.bookList.length
              "
              @change="clickSearch(false, false)"
              v-model="newParam.sortType"
            >
              <el-option
                v-for="item in sortTypeList"
                :key="item.key"
                :value="item.key"
                :label="item.name"
              >
              </el-option>
            </el-select>
            <el-select
              style="width: 80px"
              size="small"
              v-if="
                isSearching &&
                searchResult.bookList &&
                searchResult.bookList.length
              "
              @change="clickSearch(false, false)"
              v-model="newParam.sort"
            >
              <el-option
                v-for="item in sortOption"
                :key="item.key"
                :value="item.key"
                :label="item.name"
              >
              </el-option>
            </el-select> -->
            <!-- v-if="
                isSearching &&
                searchResult.bookList &&
                searchResult.bookList.length
              " -->
<!--            <span
              class="open-all-btn"
              :title="typeof activeName == 'string' ? '全部展开' : '全部收起'"
            >
              &lt;!&ndash; <i
                :class="
                  typeof activeName === 'string'
                    ? 'el-icon-arrow-right'
                    : 'el-icon-arrow-down'
                "
                @click="openAllBook()"
              /> &ndash;&gt;

              <span @click="openAllBook()">{{
                activeName == "" ? "一般模式" : "最简模式"
              }}</span>
            </span>-->
            <span style="margin-right: 10px">
               <el-checkbox v-model="limitChose" @change="clickSearch(true)">仅显示有权限的内容</el-checkbox>
            </span>
            <span
              class="open-all-btn"
            >
              <!-- <i
                :class="
                  typeof activeName === 'string'
                    ? 'el-icon-arrow-right'
                    : 'el-icon-arrow-down'
                "
                @click="openAllBook()"
              /> -->

              <span @click="openAllBook()">{{
                  activeName == "" ? "一般模式" : "最简模式"
                }}</span>
            </span>
          </div>
        </div>
        <!-- 搜索正文
         v-infinite-scroll="newload"
            infinite-scroll-disabled="newdisabled"
            infinite-scroll-distance="10"
         " -->
<!--        <el-card>
          <div
            class="heitani"
            :style="{ height: contHeight - 10 + 'vh', overflowY: 'scroll' }"
            v-if="searchResult.bookList && searchResult.bookList.length"
          >
            &lt;!&ndash; Collapse 折叠面板 &ndash;&gt;
            <el-collapse :value="activeName" @change="getBookListOpenStatus">
              <el-collapse-item
                :disabled="!isSearching"
                v-for="(item, index) in searchResult.bookList"
                :key="index"
                :name="item.bookName"
              >
                <template #title>
                  <span
                    :key="activeName && activeName[item.bookName]"
                    class="head-title justify-between cursorauto"
                  >
                    <div>
                      <span
                        class="cursorpointer"
                        @click="
                          viewDetail(
                            { juanNum: '' },
                            item.id,
                            '',
                            item.bookName
                          )
                        "
                        >{{ item.bookName }}</span
                      >
                      &lt;!&ndash; @click.stop="gotoBookDetail(item)" &ndash;&gt;
                      &lt;!&ndash; <span class="book-number">（越南之部一册）</span> &ndash;&gt;
                      <span class="sm-title">{{ item.hitNum }}条</span>
                      <i
                        style="margin-left: 24px"
                        :class="
                          openSearchStatus[item.bookName]
                            ? 'el-icon-arrow-right'
                            : 'el-icon-arrow-down'
                        "
                        @click.stop="closeAllList(item)"
                      />
                      <div class="search-content-box" @click.stop="">
                        <div class="search-info-box flex">
                          <span class="search-info align-center">
                            {{ item.categoryName }}
                          </span>
                          <span class="search-info align-center">
                            &lt;!&ndash; <img src="/static/icon/user.png" class="icon" /> &ndash;&gt;
                            {{ item.writer }}
                            &lt;!&ndash;                            <ul v-for="(w, key, i) in item.writerarr" :key="i">&ndash;&gt;
                            &lt;!&ndash;                              <li v-if="i != 0">，</li>&ndash;&gt;
                            &lt;!&ndash;                              <li v-for="(ww, ii) in w" :key="ii">&ndash;&gt;
                            &lt;!&ndash;                                <i v-if="ii != 0">、</i>&ndash;&gt;
                            &lt;!&ndash;                                [{{ ww.writerDynastyName }}]<i&ndash;&gt;
                            &lt;!&ndash;                                  @click="&ndash;&gt;
                            &lt;!&ndash;                                    linkdialog(&ndash;&gt;
                            &lt;!&ndash;                                      item.writerList,&ndash;&gt;
                            &lt;!&ndash;                                      item.copierList,&ndash;&gt;
                            &lt;!&ndash;                                      ww.writerName,&ndash;&gt;
                            &lt;!&ndash;                                      item.bookName&ndash;&gt;
                            &lt;!&ndash;                                    )&ndash;&gt;
                            &lt;!&ndash;                                  "&ndash;&gt;
                            &lt;!&ndash;                                  class="cursor"&ndash;&gt;
                            &lt;!&ndash;                                  >{{ ww.writerName }}</i&ndash;&gt;
                            &lt;!&ndash;                                >&ndash;&gt;
                            &lt;!&ndash;                                &lt;!&ndash; <i v-if="ii + 1 == w.length">{{ key }}</i> &ndash;&gt;&ndash;&gt;
                            &lt;!&ndash;                              </li>&ndash;&gt;
                            &lt;!&ndash;                            </ul>&ndash;&gt;
                          </span>
                          <span
                            class="search-info align-center"
                            v-if="item.copierList"
                          >
                            &lt;!&ndash; <img src="/static/icon/auth.png" class="icon" /> &ndash;&gt;
                            &lt;!&ndash; {{ item.copier }}校點 &ndash;&gt;
                            <span v-for="(c, ci) in item.copierList" :key="ci"
                              ><i v-if="ci != 0">、</i
                              ><i
                                @click="
                                  linkdialog(
                                    item.writerList,
                                    item.copierList,
                                    c.copierName,
                                    item.bookName
                                  )
                                "
                                class="cursor"
                                >{{ c.copierName }}</i
                              ></span
                            >校
                          </span>
                          &lt;!&ndash; <span class="search-info align-center">
                            <img
                              v-if="item.dcUrl"
                              src="/static/icon/temp.png"
                              class="icon"
                            />
                            <img
                              v-else
                              src="/static/icon/temp1.png"
                              :style="{ width: '1.35rem', height: '1.35rem' }"
                              class="icon"
                            />

                            底本參考
                          </span> &ndash;&gt;
                          <span class="search-info align-center">
                            {{ item.publishTime }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span>{{ activeName && activeName[item.bookName] }}</span>
                    <div>
                      &lt;!&ndash; 该icon透明度为0，模拟原来的按钮不能传参 ,同事slot不更新数据，所以原箭头禁止鼠标事件，只负责展示 &ndash;&gt;
                      <i
                        :class="
                          activeName && activeName[item.bookName]
                            ? 'el-icon-arrow-right'
                            : 'el-icon-arrow-down'
                        "
                        @click.stop="openBook(item)"
                      ></i>
                      <span class="booksss" @click.stop="gotoBookDetail(item)"
                        >书籍介绍</span
                      >
                      <span
                        class="booksss"
                        @click.stop="addReadListBox(item.id)"
                        >添加到书单</span
                      >
                    </div>
                  </span>
                </template>
                <div class="search-content-box" v-if="searchFilter.type != 3">
                  &lt;!&ndash; <el-collapse
                  v-model="activeListName[item.id]"

                  accordion
                > &ndash;&gt;
                  <div
                    v-for="(list, idx) in item.bookJuanList"
                    :key="`${idx}${list.juanName}`"
                    v-if="
                      idx == 0 ||
                      openSearchStatus[item.id] ||
                      openSearchStatus[item.bookName]
                    "
                    :name="list.juanName"
                  >
                    <div class="juan-title justify-between">
                      <span
                        style="cursor: pointer"
                        @click="
                          viewDetail(
                            { juanNum: list.juanNum },
                            item.id,
                            '',
                            item.bookName
                          )
                        "
                      >
                        {{ list.juanName }}
                        &lt;!&ndash;                        <span class="num"> 命中{{ list.hitNum }}次 </span>&ndash;&gt;
                      </span>
                      <div
                        @click="
                          openJuanStatus[list.juanName] =
                            !openJuanStatus[list.juanName];
                          $forceUpdate();
                        "
                      >
                        <i
                          :class="
                            openJuanStatus[list.juanName]
                              ? 'el-icon-arrow-right'
                              : 'el-icon-arrow-down'
                          "
                        />
                      </div>
                    </div>
                    <div v-if="!openJuanStatus[list.juanName]">
                      <div
                        class="search-content flex list"
                        :key="page.id + page.text"
                        v-for="(page, index) in list.bookPageList"
                        v-if="
                          index < 3 ||
                          openSearchStatus[item.id] ||
                          openSearchStatus[item.bookName]
                        "
                      >
                        <div class="sort">
                          {{ index + 1 }}.

                          <i
                            class="el-icon-warning-outline"
                            v-if="page.hitType == 2"
                          />
                        </div>
                        <div
                          class="content cursorpointer"
                          @click="
                            viewDetail(
                              page,
                              page.bookId,
                              page.id,
                              item.bookName
                            )
                          "
                          v-html="page.text"
                        ></div>
                        &lt;!&ndash; <img
                          class="book-icon"
                          @click="
                            viewDetail(
                              page,
                              page.bookId,
                              page.id,
                              item.bookName
                            )
                          "
                          src="/static/icon/view.png"
                        /> &ndash;&gt;
                      </div>
                    </div>
                    &lt;!&ndash; 剩余 &ndash;&gt;
                    <div
                      v-show="
                        (item.bookJuanList.length > 1 ||
                          list.bookPageList.length > 3) &&
                        !openSearchStatus[item.id] &&
                        !openSearchStatus[item.bookName]
                      "
                      class="justify-between"
                    >
                      <a></a>
                      <a style="cursor: pointer" @click="viewMoreList(item)"
                        >更多結果>></a
                      >
                    </div>
                  </div>
                  &lt;!&ndash; </el-collapse> &ndash;&gt;
                </div>
                <div
                  class="mengban"
                  v-if="item.isPermit == 0"
                  @click="clickChangeBuy(true)"
                ></div>
              </el-collapse-item>
            </el-collapse>
            &lt;!&ndash; <p v-if="newloading">加载中...</p>
            <p v-if="noMore">
              {{
                isSearching
                  ? "以上就是本次檢索的所有結果"
                  : "以上就是本次選中的所有結果"
              }}
            </p> &ndash;&gt;
            <el-pagination
              style="margin: 20px auto; text-align: center"
              background
              layout="prev, pager, next"
              :total="searchResult.total"
              @current-change="pageChange"
              :current-page="newParam.pageNum"
              :page-size="newParam.pageSize"
            >
            </el-pagination>
            &lt;!&ndash; </div> &ndash;&gt;
            &lt;!&ndash; 分页 &ndash;&gt;
            &lt;!&ndash; <div class="justify-end" style="font-size:25px;padding-top:10px" v-else>
              <el-pagination
                @current-change="empSearchChange"
                layout="prev, pager, next,total"
                :total="empsearch.total"
                :current-page="empsearch.pageNum"
                :page-size="empsearch.pageSize"
                prev-text="上一頁"
                next-text="下一頁"
              >
              </el-pagination>
            </div> &ndash;&gt;
            &lt;!&ndash; 分页end &ndash;&gt;
          </div>
          <el-empty
            class="heitani"
            v-else
            :style="{ height: contHeight + 'vh' }"
            :image-size="200"
            :description="description"
            image="/static/icon/1.gif"
          ></el-empty>
        </el-card>-->
        <el-card>
          <div
            class="heitani"
            :style="{ height: contHeight - 10 + 'vh', overflowY: 'scroll' }"
            v-if="searchResult.bookList && searchResult.bookList.length"
          >
            <!-- Collapse 折叠面板 -->
            <el-collapse :value="activeName" @change="getBookListOpenStatus">

              <el-collapse-item
                :disabled="!isSearching"
                v-for="(item, index) in searchResult.bookList"
                :key="index"
                :name="item.bookName"
                class="itemStyle"
              >
                <template #title>
                  <span
                    :key="activeName && activeName[item.bookName]"
                    class="head-title justify-between cursorauto"
                  >
                    <div>
                      <span>
                        <i @click="
                          viewDetail(
                            { juanNum: '' },
                            item.id,
                            '',
                            item.bookName,
                            item.isLock
                          )
                        " v-show="item.isLock" class="el-icon-lock" style="opacity: 1;font-size: 15px;margin-right: 0"></i>
<!--                        <i v-show="!item.isLock" class="el-icon-unlock" style="opacity: 1;font-size: 15px;margin-right: 0"></i>-->
                      </span>
                      <span
                        class="cursorpointer"
                        @click="
                          viewDetail(
                            { juanNum: '' },
                            item.id,
                            '',
                            item.bookName,
                            item.isLock
                          )
                        "
                      >{{ item.bookName }}</span
                      >
                      <!-- @click.stop="gotoBookDetail(item)" -->
                      <!-- <span class="book-number">（越南之部一册）</span> -->
                      <span class="sm-title" v-if="(newParam.searchType!=='3')&&(item.bookJuanList.length)">{{item.bookJuanList[0].bookPageList.length }}条</span>
                      <i
                        style="margin-left: 24px"
                        :class="
                          openSearchStatus[item.bookName]
                            ? 'el-icon-arrow-right'
                            : 'el-icon-arrow-down'
                        "
                        @click.stop="closeAllList(item)"
                      />
                      <div class="search-content-box" @click.stop="">
                        <div class="search-info-box flex">
                          <span class="search-info align-center">
                            {{ item.categoryName }}
                          </span>
                          <span class="search-info align-center">
                            <!-- <img src="/static/icon/user.png" class="icon" /> -->
                            {{ item.writer }}
                            <!--                            <ul v-for="(w, key, i) in item.writerarr" :key="i">-->
                            <!--                              <li v-if="i != 0">，</li>-->
                            <!--                              <li v-for="(ww, ii) in w" :key="ii">-->
                            <!--                                <i v-if="ii != 0">、</i>-->
                            <!--                                [{{ ww.writerDynastyName }}]<i-->
                            <!--                                  @click="-->
                            <!--                                    linkdialog(-->
                            <!--                                      item.writerList,-->
                            <!--                                      item.copierList,-->
                            <!--                                      ww.writerName,-->
                            <!--                                      item.bookName-->
                            <!--                                    )-->
                            <!--                                  "-->
                            <!--                                  class="cursor"-->
                            <!--                                  >{{ ww.writerName }}</i-->
                            <!--                                >-->
                            <!--                                &lt;!&ndash; <i v-if="ii + 1 == w.length">{{ key }}</i> &ndash;&gt;-->
                            <!--                              </li>-->
                            <!--                            </ul>-->
                          </span>
                          <span
                            class="search-info align-center"
                            v-if="item.copierList"
                          >
                            <!-- <img src="/static/icon/auth.png" class="icon" /> -->
                            <!-- {{ item.copier }}校點 -->
                            <span v-for="(c, ci) in item.copierList" :key="ci"
                            ><i v-if="ci != 0">、</i
                            ><i
                              @click="
                                  linkdialog(
                                    item.writerList,
                                    item.copierList,
                                    c.copierName,
                                    item.bookName
                                  )
                                "
                              class="cursor"
                            >{{ c.copierName }}</i
                            ></span
                            >校
                          </span>
                          <!-- <span class="search-info align-center">
                            <img
                              v-if="item.dcUrl"
                              src="/static/icon/temp.png"
                              class="icon"
                            />
                            <img
                              v-else
                              src="/static/icon/temp1.png"
                              :style="{ width: '1.35rem', height: '1.35rem' }"
                              class="icon"
                            />

                            底本參考
                          </span> -->
                          <span class="search-info align-center">
                            {{ item.publishTime }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span>{{ activeName && activeName[item.bookName] }}</span>
                    <div>
                      <!-- 该icon透明度为0，模拟原来的按钮不能传参 ,同事slot不更新数据，所以原箭头禁止鼠标事件，只负责展示 -->
                      <i
                        :class="
                          activeName && activeName[item.bookName]
                            ? 'el-icon-arrow-right'
                            : 'el-icon-arrow-down'
                        "
                        @click.stop="openBook(item)"
                      ></i>
<!--                      <span class="booksss" @click.stop="gotoBookDetail(item)"
                      ><i class="el-icon-s-order flagImg"></i>书籍介绍</span
                      >-->
                      <span
                        class="booksss"
                        @click.stop="addReadListBox(item.id)"
                      ><i class="el-icon-notebook-2 flagImg"></i>添加到书单</span
                      >
                    </div>
                  </span>
                </template>
                <div style="display: flex">
                  <div class="search-content-box" v-if="(searchFilter.type != 3)&&(item.bookJuanList.length>0)">
                    <!-- <el-collapse
                    v-model="activeListName[item.id]"

                    accordion
                  > -->
                    <div
                      v-for="(list, idx) in item.bookJuanList"
                      :key="`${idx}${list.juanName}`"
                      v-if="
                      idx == 0 ||
                      openSearchStatus[item.id] ||
                      openSearchStatus[item.bookName]
                    "
                      :name="list.juanName"
                    >
                      <div class="juan-title justify-between">
                        <!--                      <span
                                                style="cursor: pointer"
                                                @click="
                                                  viewDetail(
                                                    { juanNum: list.juanNum },
                                                    item.id,
                                                    '',
                                                    item.bookName
                                                  )
                                                "
                                              >
                                                {{ list.juanName }}
                                                &lt;!&ndash;                        <span class="num"> 命中{{ list.hitNum }}次 </span>&ndash;&gt;
                                              </span>-->
                        <!--                      <div
                                                @click="
                                                  openJuanStatus[list.juanName] =
                                                    !openJuanStatus[list.juanName];
                                                  $forceUpdate();
                                                "
                                              >
                                                <i
                                                  :class="
                                                    openJuanStatus[list.juanName]
                                                      ? 'el-icon-arrow-right'
                                                      : 'el-icon-arrow-down'
                                                  "
                                                />
                                              </div>-->
                      </div>
                      <div v-if="!openJuanStatus[list.juanName]">
                        <div
                          class="search-content flex list"
                          :key="page.id + page.text"
                          v-for="(page, index1) in list.bookPageList"
                          v-if="
                          index1 < 3 ||
                          openSearchStatus[item.id] ||
                          openSearchStatus[item.bookName]
                        "
                        >
                          <div class="sort">
                            {{ index1 + 1 }}.&nbsp;

                            <i
                              class="el-icon-warning-outline"
                              v-if="page.hitType == 2"
                            />
                          </div>
                          <div
                            class="content cursorpointer"
                            @click="
                            viewDetail(
                              page,
                              page.bookId,
                              page.id,
                              item.bookName,
                              item.isLock
                            )
                          "
                            v-html="extractFirstSpanWithContext(page.text)"
                          ></div>
                          <!-- <img
                            class="book-icon"
                            @click="
                              viewDetail(
                                page,
                                page.bookId,
                                page.id,
                                item.bookName
                              )
                            "
                            src="/static/icon/view.png"
                          /> -->
                        </div>
                      </div>
                      <!-- 剩余 -->
                      <div
                        v-show="
                         list.bookPageList.length > 3
                      "
                        style="text-align: center;font-weight: bold;color: #795636"
                      >
                        <div style="cursor: pointer;line-height: 5px;margin-top: 10px;" @click="viewMoreList(item)"
                        >更多結果</div
                        >
                        <div>︾</div>
                      </div>
<!--                      <div v-show="list.flag" @click="list.flag=false" style="text-align: right;font-family: PingFangSC, PingFang SC;font-weight: 400;font-size: 12px;color: #E9B63E;">
                        更多结果
                        <i class="el-icon-arrow-down"></i>
                      </div>
                      <div v-show="(!list.flag)&&(list.bookPageList.length>3)" @click="list.flag=true" style="text-align: right;font-family: PingFangSC, PingFang SC;font-weight: 400;font-size: 12px;color: #E9B63E;">
                        收起本书
                        <i class="el-icon-arrow-up"></i>
                      </div>-->
                    </div>

<!--                    <PaginationNew
                      :total-pages="item.bookJuanList.length"
                      :custom-param="index"
                      @page-change="handlePageChange"
                    />-->
                    <!-- </el-collapse> -->
                  </div>

                  <div
                    class="mengban"
                    v-if="item.isPermit == 0"
                    @click="clickChangeBuy(true)"
                  ></div>
                </div>
              </el-collapse-item>

            </el-collapse>
            <!-- <p v-if="newloading">加载中...</p>
            <p v-if="noMore">
              {{
                isSearching
                  ? "以上就是本次檢索的所有結果"
                  : "以上就是本次選中的所有結果"
              }}
            </p> -->
            <el-pagination
              style="margin: 20px auto; text-align: center"
              background
              layout="prev, pager, next"
              :total="searchResult.total"
              @current-change="pageChange"
              :current-page="newParam.pageNum"
              :page-size="newParam.pageSize"
            >
            </el-pagination>
            <!-- </div> -->
            <!-- 分页 -->
            <!-- <div class="justify-end" style="font-size:25px;padding-top:10px" v-else>
              <el-pagination
                @current-change="empSearchChange"
                layout="prev, pager, next,total"
                :total="empsearch.total"
                :current-page="empsearch.pageNum"
                :page-size="empsearch.pageSize"
                prev-text="上一頁"
                next-text="下一頁"
              >
              </el-pagination>
            </div> -->
            <!-- 分页end -->
          </div>
          <el-empty
            class="heitani"
            v-else
            :style="{ height: contHeight + 'vh' }"
            :image-size="200"
            :description="description"
            image="/static/icon/1.gif"
          ></el-empty>
        </el-card>
      </div>
    </div>
    <!-- 关系图预览 -->
    <!-- <el-dialog
      :title="activewriter"
      :visible.sync="linkVisible"
      width="70%"
      height="60%"
      min-width="900px"
    >
      <EchartGx
        :writerIds="writerIds"
        :copierIds="copierIds"
        :activewriter="activewriter"
        :bookName="activeBookName"
      ></EchartGx>
    </el-dialog> -->
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus.js"
// import Analysis from "./analysis.vue"
// import EchartGx from "@/components/echart-gxnew.vue"
import {
  getInfo,
  getlistByIdsApi,
  // getBookList,
  booksTree,
  essearch,
  // getCategoryNode,
  getDynastyListNew,
  // getWriterList,
  // getMainSum,
  // getNoteSum,
  readinglistBySearch,
  newGetCategoryNode,
  newGetWriterList,
  exportSearchResult,
  getHitCount,
  addLatest
} from "@/api/api"
import PaginationNew from "../components/PaginationNew.vue";
// import moment from "moment";
export default {
  name: "WordTest",
  components: {
    PaginationNew
    // Analysis,
    // EchartGx,
  },
  data () {
    return {
      limitChose:false,
      keywordAll:'',
      // isReload: true,
      readinglist: [],//书单
      writerList: [],
      catalist: [],//分类
      dynastylist: [],
      dynasty: '',
      showmenu: false,
      isShowQuanKu: true,//是否展示全库按钮 沒登錄不展示
      emptyText: "查詢中...",

      historyList: { keyword: [], advanced1: [], advanced2: [] },//历史记录
      linkVisible: false,
      activeBookName: "",//关系图弹窗 书名
      activewriter: "",//关系图弹窗 查询作者
      writerIds: [],//关系图弹窗作者或校验Id
      copierIds: [],//关系图弹窗作者或校验Id
      dialogTableVisible: false,//数据分析柱状图默认不展示
      xAxisdata: [],//条形统计图数据
      seriesdata: [],//条形统计图数据
      // leftHeight:'86vh',
      // contHeight:'76vh',
      leftHeight: 77,
      contHeight: 77,
      isShow: true,//搜索框是否展示
      chaoShow: false,
      changestate: "全部展开",
      searchWord: "",
      search: {
        //搜索框数据
        pinyin: "",
      },
      description: "请在上方输入关键词检索，或者在左侧选择筛选项",
      searchParams: {
        // keyword: "正文"
        // advaList: {}
      },
      // sortType:0,//排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
      searchResult: {
        bookList: [],
        total: 0
      },
      // searchType: "1",
      rangeType: "1",
      newIsCheck: false,//新增自定义范围
      customRangeType: "category",
      isAuth: "pinyin",
      isVisiableCustomRange: false,
      checkList: [],
      checkLists: [],
      advancedQuery: [
        {
          type: "and",
          textType: "0",
          keyword: "",
        },
        {
          type: "and",
          textType: "0",
          keyword: "",
        },
      ],
      neardQuery: [
        {
          spacing: 5,
          keyword: "",
        },
        {
          spacing: 5,
          type: "and",
          keyword: "",
        },
      ],
      selectTreeIndex: 0,
      treeList: {
        category: [], // 类目
        pinyin: [], // 拼音
        dynasty: [], // 朝代
      },

      searchTreeProps: {
        key: "id",
        // children: "children",
        label: (item, data) => {
          return item.showName
        },
        // label: (item, data) => {
        //   return item.name + "（" + item.num + "）"
        // },
        // disabled: (item, data) => {
        //   if (item.isPermit == 1) {
        //     return false
        //   } else {
        //     return true
        //   }

        // },
      },
      defaultProps: {
        children: "children",
        label: "name",
      },
      defaultTreeProps: {
        children: "children",
        label: "name",
        disabled: (item, data) => {
          if (item.isPermit == 1) {
            return false
          } else {
            return true
          }

        },
      },
      activeName: "",
      activeListName: {},
      uuid: "",
      // sortOption: [
      //   {
      //     key: "0",
      //     name: "正序",
      //   },
      //   {
      //     key: "1",
      //     name: "倒序",
      //   },
      // ],
      // writerIds: [],
      searchFilter: {
        categoryNames: [],
        dynastyNames: [],
        bookReadingListIds: []
      },
      isSimple: true,
      searchParamsList: {
        category: {},
        pinyin: {},
        dynasty: {},
      },
      sort: "0", //排序 0 正序 1倒序
      // sortTypeList: [
      //   { key: 0, name: "默認" },
      //   { key: 1, name: "朝代" },
      //   { key: 2, name: "數量" },
      // ],
      searchTree: {
        tree: 1,
        writer: 1,
        dynasty: 1,
      },
      isSearchFilter: false,
      openSearchStatus: {},
      openJuanStatus: {},
      rightOpera: {},
      isCategorySearch: false,
      isDynastySearch: false,
      isPinyinSearch: false,
      isSearching: false,
      loading: false,
      // saerchInfo: {
      //   total: 0,
      //   pageSize: 10,
      //   pageNum: 1
      // },
      empsearch: {
        //搜索空置的情况下分页
        total: 0,
        pageSize: 10,
        pageNum: 1,
        ids: "",
      },
      downLoading: false,
      newloading: false, //滚动加载
      searchAccuracyType: true,//精确or模糊搜索 0 精确 1模糊
      newParam: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        keyword: "",
        type: 0,
        searchType: "0",
        sort: "1", //排序 0 正序 1倒序
        sortType: 2, //排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
        categoryNames: [],
        dynastyNames: [],
        bookReadingListIds: "",
        bookIds: "",
        advaList: [],
        hitCountType: 0,
        isInnerSearch: 0,//0 全局 1书内检索
        searchAccuracyType: 1,
        isOnlyPermit: 1,//是否全库 0 全局 1仅授权
        textType: "0"
      },
      keywordStr: "", //云~$花蕋~!书   ~代表关键字的分隔符，$意思是条件or， !意思是条件not, 关键字前面没有 $和!代表 and
      xdwenxian: "",//选定文献
      numresult: 0,
      numBookResult: 0,
      fenlei: "",
      zuozhe: "",
      zuozhelist: [],
      shudan: ""
    }
  },
  watch: {
    // searchType: d => {
    //   console.log(d);
    // }
    isShow: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          if (this.newParam.searchType == 0 || this.newParam.searchType == 3) {
            this.leftHeight = 77
            this.contHeight = 77
          } else {
            this.leftHeight = 56
            this.contHeight = 56
          }
        } else {
          this.leftHeight = 84
          this.contHeight = 84
        }
      }
    },
    'newParam.searchType' (newVal) {
      if (this.isShow) {
        if (newVal == 0 || newVal == 3) {
          this.leftHeight = 77
          this.contHeight = 77
        } else {
          this.leftHeight = 56
          this.contHeight = 56
        }
      } else {
        this.leftHeight = 84
        this.contHeight = 84
      }

    }

  },
  created () {
    this.keywordAll=''
    //this.getTreeData()
    if (this.$route.query && this.$route.query.searchType) {
      this.newParam.searchType = this.$route.query.searchType
      if (this.newParam.searchType == 1 && this.$route.query.advaList) {
        this.advancedQuery=  this.$route.query.advaList
      }
      if (this.newParam.searchType == 2 && this.$route.query.advaList) {
        this.neardQuery=  this.$route.query.advaList
      }
    }
    if (this.$route.query && this.$route.query.keyword) {
      this.newParam.keyword = this.$route.query.keyword
      this.clickSearch(true)
    }

  },
  computed: {
    noMore () {
      if (this.isSearching) {
        return this.newParam.total < this.newParam.pageSize

      } else {
        // return this.empsearch.total <= this.empsearch.pageSize * this.empsearch.pageNum
        return this.empsearch.pageNum >= Math.ceil(this.empsearch.total / this.empsearch.pageSize)
        // return false;
      }
    },
    newdisabled () {
      return this.newloading || this.noMore
    },
  },
  mounted () {
    // console.log(this.$route.params.operStr, 'this.$route.params.yourKey')

    this.mountedmove()
    this.$bus.$on('changeShow', this.changeShow)

    this.$bus.$on('reloadSearch', () => {
      this.mountedmove()
    })

    this.$bus.$on('readinglistBySearchF', this.readinglistBySearchF)

    // document.addEventListener('click', this.handleClickOutside)

    // this.$bus.$on('acceptparam', (str) => {
    //   let s = JSON.parse(str)
    //   console.log(s)
    //   this.newParam.keyword = s.keyword
    //   this.newParam.searchType = s.searchType
    //   this.advancedQuery = s.advancedQuery
    //   this.nearQuery = s.nearQuery

    // })
    // getCategoryNode().then(data => {
    //   this.searchResult.tree = data.data;
    //   this.$forceUpdate();
    // });

    // window.addEventListener("mousemove",this.getgetPosY);
    //  window.addEventListener('mousewheel', this.handleScroll, true)||window.addEventListener("DOMMouseScroll",this.handleScroll,false)
    //历史记录

    // console.log(this.$route.path, 'route.path')


  },
  methods: {
   /* extractFirstSpanWithContext (htmlString, contextLength = 28) {
      // 1. 创建临时DOM容器
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // 2. 查找第一个span元素
      const firstSpan = tempDiv.querySelector('span');
      if (!firstSpan) return null;

      // 3. 收集所有连续的span元素
      const spans = [firstSpan];
      let nextNode = firstSpan.nextSibling;

      while (nextNode) {
        if (nextNode.nodeType === Node.ELEMENT_NODE && nextNode.tagName === 'SPAN') {
          spans.push(nextNode);
          nextNode = nextNode.nextSibling;
        } else {
          break;
        }
      }

      // 4. 获取所有span的HTML（保留所有样式）
      const spansHTML = spans.map(span => span.outerHTML).join('');
      const spansText = spans.map(span => span.textContent).join('');

      // 5. 获取完整文本用于定位
      const fullText = tempDiv.textContent;
      const spansStart = fullText.indexOf(spansText);
      if (spansStart === -1) return null;

      // 6. 提取span前的文本（精确8个字符）
      let beforeText = '';
      let beforeChars = 0;
      let node = spans[0].previousSibling;

      // 收集前面的所有文本节点（从近到远）
      const prevTextNodes = [];
      while (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          prevTextNodes.unshift(node); // 反向插入保持顺序
        }
        node = node.previousSibling;
      }

      // 从前往后取字符（保持原始顺序）
      for (const textNode of prevTextNodes) {
        if (beforeChars >= contextLength) break;
        const text = textNode.textContent;
        const needed = contextLength - beforeChars;
        beforeText = text.slice(-needed) + beforeText;
        beforeChars += Math.min(needed, text.length);
      }

      // 7. 提取span后的文本（精确8个字符）
      let afterText = '';
      let afterChars = 0;
      node = spans[spans.length - 1].nextSibling;

      while (node && afterChars < contextLength) {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          const needed = contextLength - afterChars;
          afterText += text.slice(0, needed);
          afterChars += Math.min(needed, text.length);
        }
        node = node.nextSibling;
      }

      // 8. 构建结果字符串
      let result = '';

      // 添加前导省略号（检查前面是否还有内容）
      if (this.hasContentBefore(spans[0], beforeChars, contextLength)) {
        result += '...';
      }

      // 添加前导文本
      result += beforeText;

      // 添加所有连续的span标签（完整保留所有内容样式）
      result += spansHTML;

      // 添加后续文本
      result += afterText;

      // 添加后置省略号（检查后面是否还有内容）
      if (this.hasContentAfter(spans[spans.length - 1], afterChars, contextLength)) {
        result += '...';
      }

      return result;
    },
    hasContentBefore(node, collectedChars, requiredChars) {
      if (collectedChars < requiredChars) return false;
      let prevNode = node.previousSibling;
      while (prevNode) {
        if (prevNode.nodeType === Node.TEXT_NODE && prevNode.textContent.trim()) {
          return true;
        }
        prevNode = prevNode.previousSibling;
      }
      return false;
    },
    hasContentAfter(node, collectedChars, requiredChars) {
      if (collectedChars < requiredChars) return false;
      let nextNode = node.nextSibling;
      while (nextNode) {
        if (nextNode.nodeType === Node.TEXT_NODE && nextNode.textContent.trim()) {
          return true;
        }
        nextNode = nextNode.nextSibling;
      }
      return false;
    },*/
    extractFirstSpanWithContext(htmlString, contextLength = 28) {
      try {
        // 1. 创建临时DOM容器
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;

        // 2. 查找第一个span元素
        const firstSpan = tempDiv.querySelector('span');
        if (!firstSpan) {
          // 如果没有span标签，返回前56个字符
          const fullText = tempDiv.textContent || tempDiv.innerText || '';
          return fullText.length > 56 ? fullText.substring(0, 56) + '...' : fullText;
        }

        // 3. 收集所有连续的span元素
        const spans = [firstSpan];
        let nextNode = firstSpan.nextSibling;

        while (nextNode) {
          if (nextNode.nodeType === Node.ELEMENT_NODE && nextNode.tagName === 'SPAN') {
            spans.push(nextNode);
            nextNode = nextNode.nextSibling;
          } else {
            break;
          }
        }

        // 4. 获取所有连续span的HTML和文本
        const spansHTML = spans.map(span => span.outerHTML).join('');
        const spansText = spans.map(span => span.textContent).join('');

        // 5. 获取完整文本用于定位
        const fullText = tempDiv.textContent || tempDiv.innerText || '';
        const spansStart = fullText.indexOf(spansText);
        if (spansStart === -1) return spansHTML;

        // 6. 提取span前的文本
        let beforeHTML = '';
        let beforeChars = 0;
        let node = spans[0].previousSibling;

        // 收集前面的所有节点（从近到远）
        const prevNodes = [];
        while (node) {
          prevNodes.unshift(node); // 反向插入保持顺序
          node = node.previousSibling;
        }

        // 从前往后处理节点（保持原始顺序）
        for (const prevNode of prevNodes) {
          if (beforeChars >= contextLength) break;

          if (prevNode.nodeType === Node.TEXT_NODE) {
            const text = prevNode.textContent;
            const needed = contextLength - beforeChars;
            beforeHTML = text.slice(-needed) + beforeHTML;
            beforeChars += Math.min(needed, text.length);
          } else if (prevNode.nodeType === Node.ELEMENT_NODE) {
            // 处理元素节点（保留标签和样式）
            const nodeText = prevNode.textContent || '';
            const needed = contextLength - beforeChars;

            if (nodeText.length <= needed) {
              // 整个元素节点都可以加入
              beforeHTML = prevNode.outerHTML + beforeHTML;
              beforeChars += nodeText.length;
            } else {
              // 元素节点文本过长，需要截取
              // 这里简化处理，只取文本内容
              beforeHTML = nodeText.slice(-needed) + beforeHTML;
              beforeChars += needed;
              break;
            }
          }
        }

        // 7. 提取span后的文本（保留span标签）
        let afterHTML = '';
        let afterChars = 0;
        node = spans[spans.length - 1].nextSibling;

        while (node && afterChars < contextLength) {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            const needed = contextLength - afterChars;
            afterHTML += text.slice(0, needed);
            afterChars += Math.min(needed, text.length);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            // 处理元素节点（保留标签和样式）
            if (node.tagName === 'SPAN') {
              // 如果是span标签，完整保留
              afterHTML += node.outerHTML;
              afterChars += (node.textContent || '').length;
            } else {
              // 其他元素节点，递归处理其内容
              const nodeText = node.textContent || '';
              const needed = contextLength - afterChars;

              if (nodeText.length <= needed) {
                // 整个元素节点都可以加入
                afterHTML += node.outerHTML;
                afterChars += nodeText.length;
              } else {
                // 元素节点文本过长，需要截取其内容
                // 这里简化处理，只取文本内容
                afterHTML += nodeText.slice(0, needed);
                afterChars += needed;
                break;
              }
            }
          }

          // 移动到下一个节点
          node = afterChars < contextLength ? node.nextSibling : null;
        }

        // 8. 构建结果字符串
        let result = '';

        // 添加前导省略号（检查前面是否还有内容）
        if (this.hasContentBefore(spans[0], beforeChars, contextLength)) {
          result += '...';
        }

        // 添加前导文本
        result += beforeHTML;

        // 添加所有连续的span标签（完整保留所有内容样式）
        result += spansHTML;

        // 添加后续文本
        result += afterHTML;

        // 添加后置省略号（检查后面是否还有内容）
        if (this.hasContentAfter(spans[spans.length - 1], afterChars, contextLength)) {
          result += '...';
        }

        return result;
      } catch (error) {
        console.error('Error in extractFirstSpanWithContext:', error);
        // 出错时返回原始HTML的前56个字符
        const textOnly = htmlString.replace(/<[^>]*>/g, '');
        return textOnly.length > 56 ? textOnly.substring(0, 56) + '...' : textOnly;
      }
    },

    hasContentBefore(node, collectedChars, requiredChars) {
      if (collectedChars < requiredChars) return false;
      let prevNode = node.previousSibling;
      while (prevNode) {
        if (prevNode.nodeType === Node.TEXT_NODE && prevNode.textContent.trim()) {
          return true;
        } else if (prevNode.nodeType === Node.ELEMENT_NODE) {
          // 检查元素节点是否有内容
          const text = prevNode.textContent || '';
          if (text.trim()) return true;
        }
        prevNode = prevNode.previousSibling;
      }
      return false;
    },

    hasContentAfter(node, collectedChars, requiredChars) {
      if (collectedChars < requiredChars) return false;
      let nextNode = node.nextSibling;
      while (nextNode) {
        if (nextNode.nodeType === Node.TEXT_NODE && nextNode.textContent.trim()) {
          return true;
        } else if (nextNode.nodeType === Node.ELEMENT_NODE) {
          // 检查元素节点是否有内容
          const text = nextNode.textContent || '';
          if (text.trim()) return true;
        }
        nextNode = nextNode.nextSibling;
      }
      return false;
    },
    handlePageChange({ page, customParam }) {
      let pageIndex=page-1
      this.searchResult.bookList[customParam].bookJuanListBox=[this.searchResult.bookList[customParam].bookJuanList[pageIndex]]
    },
    contolNumber (cvalue) {
      console.log(cvalue, 'cvalue')
      if (cvalue > 30) {
        return this.$message.warning("最大值30")
      }
      if (cvalue < 1) {
        return this.$message.warning("最小值1")
      }
    },
    fenleiSearch () {

      this.getCategoryNodeData({ keyword: this.fenlei })
    },
  /*  zuozheSearch () {

      this.getWriterList(this.zuozhe)
    },*/
    shudanSearch () {
      this.readinglistBySearchF(this.shudan)
    },

    addReadListBox (id) {
      eventBus.$emit("doChangeTwoVisible", true, id)
    },
    readinglistBySearchF (key) {
      let query = { pageNum: 1, pageSize: 1000, keyword: key }

      readinglistBySearch(query).then(
        (d) => {
          if (d.data && d.data.length == 0) {
            this.emptyText = "暫無數據"
          }
          this.readinglist = [...d.userSearchRangeVoList, ...d.systemSearchRangeVoList]
        },

      )

    },
    searchTypechan () {
      // console.log('aaa')
      if (this.newParam.searchType != 0) {
        this.showmenu = true

      }
    },
    //点击空白处关闭弹窗 // 判断点击的区域是否在弹窗外部
    handleClickOutside (event) {

      if (this.showmenu && !this.$refs.popop.contains(event.target)) {
        this.showmenu = false
      }
    },
    mountedmove () {
      //判断是否游客 是否有权限
      // this.isHaveLimits()
      const { params, query } = this.$route
      // this.$route.params.operStr
      //this.getWriterList('')
      this.getCategoryNodeData({})
      this.readinglistBySearchF()
      this.getDynastyListNew()
      //操作列表跳转参数
      if (params.operStr) {
        let operStr = JSON.parse(params.operStr)
        const { keyword, searchType, advancedQuery, nearQuery, sortType, sort, searchFilter, textType } = operStr
        // console.log(nearQuery, 'nearQuery')
        if (searchType) {
          this.newParam.searchType = searchType
        }
        if (keyword) {
          this.newParam.keyword = keyword
        }
        if (advancedQuery) {
          this.advancedQuery = advancedQuery
        }
        if (nearQuery) {
          this.neardQuery = nearQuery
        }
        if (searchFilter) {
          this.searchFilter = searchFilter
        }
        console.log(this.searchFilter, 'this.searchFilter')
        if (textType) {
          this.newParam.textType = textType
        }
        // this.newParam.sortType = sortType
        // this.newParam.sort = sort
        // this.newParam = operStr
        this.clickSearch()
      }

      //操作列表

      getInfo({ 'noopenlogin': true }).then(d => {
        if (d.code == 200) {
          this.isShowQuanKu = true
          let user = d.user
          if (user.isVip == 0 && user.haveAuth == 0) {
            this.newParam.isOnlyPermit = 0
            this.isSimple = false
          } else {
            // console.log('else', this.isSimple)
            this.newParam.isOnlyPermit = 1
            this.isSimple = true
          }
        } else {
          this.isShowQuanKu = false
          this.newParam.isOnlyPermit = 0
          this.isSimple = false
        }
        if (params.keyword || query.keyword || this.newParam.keyword) {
          // this.search = { keyword: query.keyword, advaList: [] };
          this.newParam.keyword = params.keyword || query.keyword || this.newParam.keyword
          this.clickSearch(true)
        } else {
          // this.getCategoryNodeData()
        }
      })

      if (JSON.parse(localStorage.getItem("historyList"))) {
        this.historyList = JSON.parse(localStorage.getItem("historyList"))
      }
    },
    // reloadSearch (btn, left) {
    //   this.searchResult.bookList = []
    //   this.newParam.pageNum = 1
    //   this.newParam.total = 0
    //   this.postSearch(btn, left)
    // },
    //判断是否游客 是否有权限
    // isHaveLimits () {
    //   getInfo({ 'noopenlogin': true }).then(d => {
    //     if (d.code == 200) {
    //       let user = d.user
    //       if (user.isVip == 0 && user.haveAuth == 0) {
    //         this.newParam.isOnlyPermit = 0
    //         this.isSimple = false
    //       } else {
    //         // console.log('else', this.isSimple)
    //         this.newParam.isOnlyPermit = 1
    //         this.isSimple = true
    //       }
    //     } else {
    //       this.newParam.isOnlyPermit = 0
    //       this.isSimple = false
    //     }
    //   })

    // },
    rendercontent (h, { node, data, store }) {
      if (!this.isSimple && data.isPermit == 0) {
        return (<span class="el-tree-node__label" style="color:#bbb">{node.label}</span>)
      }
      else {
        return (<span class="el-tree-node__label">{node.label}</span>)
      }
    },
    //修改是否全库
    changePermit () {
      // this.newParam.isOnlyPermit = 0
      // this.getCategoryNodeData()
      this.isSimple = !this.isSimple
      this.$refs.defaultSearchTree &&
        this.$refs.defaultSearchTree.filter(this.isSimple)
    },
    changePermitTwo (isSimple, isOnlyPermit) {
      // this.searchResult.tree = []
      this.isSimple = isSimple
      //this.newParam.hitCountType = 0 // 0 获取所有（左侧加右侧） 1只获取右侧  2获取初始树 数量
      this.newParam.isOnlyPermit = parseInt(isOnlyPermit)
      // this.getSearchContent(false)
      this.searchResult.bookList = []
      this.newParam.pageNum = 1
      this.newParam.total = 0
      this.postSearch(true, false)

    },
    getStorages (queryString, cb, key) {
      // console.log(queryString, key, 'key')
      // console.log(this.historyList[key], this.historyList[key])
      if ((!this.historyList[key]) || (this.historyList[key].length == 0)) {
        cb([])
        return
      }
      let results = this.historyList[key]
      let res = []
      results.forEach((item) => {
        res.push({ value: item })
      })
      cb(res)
    },
    storageHistory (key, val) {
      //console.log(this.historyList[key], val, 'kyv')
      //没有搜索记录，把搜索值push进数组首位，存入本地
      if (!this.historyList[key]) {
        this.$set(this.historyList, key, [])
        this.historyList[key].unshift(val)
      }
      else if (!this.historyList[key].includes(val)) {
        this.historyList[key].unshift(val)
      } else {
        //有搜索记录，删除之前的旧记录，将新搜索值重新push到数组首位
        let i = this.historyList[key].indexOf(val)
        if (i != 0) {
          this.historyList[key].splice(i, 1)
          this.historyList[key].unshift(val)
        }
      }
      if (this.historyList[key] && this.historyList[key].length > 5) {
        //console.log(this.historyList[key].length, 'length')
        this.historyList[key].splice(5)
      }
      localStorage.setItem("historyList", JSON.stringify(this.historyList))
    },
    linkdialog (writerList, copierList, activewriter, bookName) {
      // if (type == 1) {
      //   this.writerIds = item.writerId
      //   this.copierIds = ''
      //   this.activewriter = item.writerName
      // } else {
      //   this.writerIds = ''
      //   this.copierIds = item.copierId
      //   this.activewriter = item.copierName
      // }
      this.writerIds = []
      this.copierIds = []
      writerList && writerList.forEach(ele => {
        this.writerIds.push({ writerId: ele.writerId, name: ele.writerName })
      })
      copierList && copierList.forEach(ele => {
        this.copierIds.push({ copierId: ele.copierId, name: ele.copierName })
      })
      this.activewriter = activewriter
      this.activeBookName = bookName
      this.linkVisible = true
      // this.$bus.$emit("linkdialog", { type, item })

    },
    handleClose (done) {
      if (this.newIsCheck && !this.xdwenxian) {
        this.newIsCheck = false
        done()
      }

    },
    getDetail (isLeaf, data) {
      if (isLeaf) {
        this.$router.push({
          name: 'Read',
          query: {
            bookId: data.realId,
            bookName: data.name,
          },
        })
      }

    },
    changeTreeIndexSearch () {
      this.searchTree.tree = this.searchTree.tree === 1 ? 0 : 1
      // this.$refs.leftCatalogList.default-expand-all = this.selectTreeIndex;
      // 折叠所有节点

      if (this.searchTree.tree == 0) {

        for (var i = 0; i < this.$refs.defaultSearchTree.store._getAllNodes().length; i++) {
          this.$refs.defaultSearchTree.store._getAllNodes()[i].expanded = false
        }
      }
      // 展开所有节点
      if (this.searchTree.tree == 1) {
        for (var i = 0; i < this.$refs.defaultSearchTree.store._getAllNodes().length; i++) {
          this.$refs.defaultSearchTree.store._getAllNodes()[i].expanded = true
        }
      }
    },

    changeShow () {
      this.isShow = !this.isShow
    },

    clearsearch () {

      // this.description = "請在上方輸入關鍵詞檢索，或者在左側選擇文獻閲讀";
      // this.isSearching = false;
      // this.searchResult = {};
      // this.newParam = {
      //   pageSize: 10,
      //   pageNum: 1,
      //   total: 0,
      //   keyword: "",
      //   type: 0,
      //   searchType: "0",
      //   sort: "0", //排序 0 正序 1倒序
      //   sortType: 0, //排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
      //   categoryIds: "",
      //   writerIds: "",
      //   dynastyIds: "",
      //   writerInitials: "",
      //   bookIds: "",
      //   advaList: [],
      //   hitCountType: 0,
      // };
      this.newParam.keyword = ''
      this.advancedQuery = [
        {
          type: "and",
          keyword: "",
          textType: "0",
        },
        {
          type: "and",
          keyword: "",
          textType: "0",
        },
      ]
      this.neardQuery = [
        {
          spacing: 5,
          keyword: "",
        },
        {
          spacing: 5,
          type: "and",
          keyword: "",
        },
      ]
      // }
      // this.getCategoryNodeData();
    },
    leftClearSearch () {
      this.searchFilter.categoryNames = []
      this.searchFilter.bookReadingListIds = []
      this.searchFilter.dynastyNames = []
      //this.$refs.treeList.setCheckedKeys([])
      this.clickSearch()

    },
    getBookListOpenStatus (a, b, c, d) {
      if (this.activeName === a) {
        this.activeName = ""
      } else if (Array.isArray(this.activeName)) {
      }
    },
    closeAllList (item) {
      // console.log('9988')
      this.openSearchStatus[item.bookName] =
        !this.openSearchStatus[item.bookName]
      item.bookJuanList.map((v) => {
        this.openJuanStatus[v.juanName] = this.openSearchStatus[item.bookName]
      })

      this.$forceUpdate()
    },
    downSearch () {
      this.downLoading = true
      exportSearchResult({
        ...this.newParam,
        pageNum: 1,
        pageSize: 1000
      }).then(
        (d) => {
          // console.log(d, 'dd')
          let date = new Date().toLocaleDateString()
          let time = new Date().toLocaleTimeString()
          let ret = this.downBlobFile(
            d,
            "“" + this.newParam.keyword + "”" + "（已授權）的搜索結果——" + date + " " + time
          )
          this.downLoading = false
          // if (ret) {
          //   this.$message('系統暫時只提供1000條的檢索結果')
          // }
        },
        () => (this.downLoading = false)
      )
    },
    getWriterList (key) {

      newGetWriterList({ keyword: key }).then(
        (d) => {
          this.zuozhelist = d.data
        },

      )
    },
    // 搜索空置情况下
    getTreeDefaultSearch (data, b, c) {
      // console.log(1)
      // this.$refs.defaultSearchTree.setCheckedKeys([data.key]);
      // getBookList({
      //   id: data.key,
      //   nodeType: data.nodeType,
      //   sort: this.sort
      // }).then(data => {
      //   // console.log(data);
      //   this.searchResult.bookList = data.data.bookList;

      //   this.openAllBook(true);
      //   this.$forceUpdate();
      // });

      let idsarr = this.$refs.defaultSearchTree.getCheckedKeys(true)
      // let ids = b.checkedKeys.join(",");
      this.empsearch.ids = idsarr.join(",")
      this.empsearch.pageNum = 1
      this.searchResult.bookList = []
      this.getlistByIds()
    },
    isornotpermit (data, b, c) {
      // console.log(2)
      if (data.isPermit == 0) { //0未授权
        // this.$router.push({ path: "/products" })
        this.clickChangeBuy(true)

      }

    },

    clickChangeBuy (isShow) {
      getInfo().then(d => {
        if (d.code == 200) {
          eventBus.$emit("changeBuy", isShow)

        }
      })
    },
    getlistByIds () {
      getlistByIdsApi({
        pageSize: this.empsearch.pageSize,
        pageNum: this.empsearch.pageNum,
        ids: this.empsearch.ids,
        // sortType: this.newParam.sortType,
        sortType: 3,
        sort: this.sort,
      }).then((data) => {
        let temprows = data.rows
        temprows.forEach((item) => {
          item.writerarr = item.writerList.reduce(function (r, a) {
            r[a.writerRole] = r[a.writerRole] || []
            r[a.writerRole].push(a)
            return r
          }, Object.create(null))
          // 日期
          // item.publishTime = (item.publishTime && item.publishTime != 'null') ? `${new Date(item.publishTime).getFullYear()}年${new Date(item.publishTime).getMonth() + 1}月` : ''
          item.publishTime = item.publishTime ? item.publishTime.substring(0, 7) : ''
        })
        this.searchResult.bookList = [...this.searchResult.bookList, ...temprows]
        this.empsearch.total = data.total
        this.isShow = false
        // this.openAllBook(true);
        this.$forceUpdate()
        this.newloading = false
      })
      // window.scrollTo(0, 0);
    },

    // 空置分页
    empSearchChange () {
      this.empsearch.pageNum += 1
      this.getlistByIds()
    },

    getTreeData () {
      this.getCategory()
      this.getPinyin()
      this.getDynasty()
    },
    clearSearchTree () {
      this.search.category = ""
      this.search.pinyin = ""
      this.search.dynasty = ""
      // this.$refs.scopeTreeCat.setCheckedKeys([]);
      // this.$refs.scopeTreeWriterDynasty.setCheckedKeys([]);
      // this.$refs.scopeTreeWriter.setCheckedKeys([]);

      // let tem1 = this.$refs.scopeTreeWriterDynasty;
      // let tem2 =  this.$refs.scopeTreeWriter.getCheckedKeys(true);
      //this.getTreeData()
    },
    gotoBookDetail (item) {
      const url = this.$router.resolve("/bookDetail?id=" + item.id)
      window.open(url.href)
    },
    gotoRead (item) {

      const url = this.$router.resolve("/read?bookId=" + item.id+'&from=sousuo' + '&bookName=' + item.bookName)
      window.open(url.href)
    },
    viewAllMoreList () {
      this.openSearchStatus = {}
      this.openJuanStatus = {}

      if (this.changestate == "全部展开") {
        this.searchResult.bookList.forEach((item) => {
          this.openSearchStatus[item.id] = true
          item.bookJuanList.map((v) => {
            this.openJuanStatus[v.juanName] = false
          })
        })

        this.changestate = "全部收起"

        this.$forceUpdate()
      } else {
        //  for(let key in this.openSearchStatus){
        //   delete this.openSearchStatus[key];
        //  }
        //  for(let key in this.openJuanStatus){
        //   delete this.openJuanStatus[key];
        //  }

        this.changestate = "全部展开"

        this.$forceUpdate()
      }
    },
    viewMoreList (item) {
      /*this.openSearchStatus[item.id] = true

      //  this.openSearchStatus[item.bookName] =
      //   !this.openSearchStatus[item.bookName];
      item.bookJuanList.map((v) => {
        this.openJuanStatus[v.juanName] = false
      })
      this.$forceUpdate()*/
      console.log(item)
     /* this.$store.commit('setItem', item)
      this.$store.commit('setNewParam',  this.newParam)
      this.$store.commit('setAdvancedQuery',  this.advancedQuery)
      this.$store.commit('setNeardQuery',  this.neardQuery)
      this.$store.commit('setSearchFilter',  this.searchFilter)*/
      localStorage.setItem('itemList', JSON.stringify(item));
      localStorage.setItem('newParam', JSON.stringify(this.newParam));
      localStorage.setItem('advancedQuery', JSON.stringify(this.advancedQuery));
      localStorage.setItem('neardQuery', JSON.stringify(this.neardQuery));
      localStorage.setItem('searchFilter', JSON.stringify(this.searchFilter));
      const url = this.$router.resolve("/searchItem")
      window.open(url.href)
    },
    openBook (item) {
      if (Array.isArray(this.activeName)) {
        const idx = this.activeName.findIndex((v) => v == item.bookName)
        if (idx > -1) {
          this.activeName.splice(idx, 1)
        } else {
          this.activeName.push(item.bookName)
        }
      } else {
        this.activeName = [item.bookName]
      }
    },
    openAllBook (isAll) {
      if (Array.isArray(this.activeName) && !isAll) {
        return (this.activeName = "")
      }
      this.activeName = this.searchResult.bookList.map((item) => item.bookName)
    },
    getFilter (isSimple, item) {
      // if (!isSimple) return true
      if (isSimple) {

        if (item.totalNum * 1 && item.isPermit == 1) {
          return true
        } else {
          return false

        }

      }
      return true
    },
    getDefaltFilter (isSimple, item) {
      if (isSimple) {
        if (item.bookTotal != "0" && item.isPermit == 1) {
          return true
        }
        return false
      }
      return true
    },
    // if (item.isPermit == 1) {
    //       return true
    //     } else {
    //       return false
    //     }
    extractSpanContents(val) {
      // 使用正则表达式匹配所有span标签
      const spanRegex = /<span[^>]*>(.*?)<\/span>/gi;
      const matches = [];
      let match;

      // 循环匹配所有span标签
      while ((match = spanRegex.exec(val)) !== null) {
        // 获取span标签内的纯文本内容
        matches.push({
          text: match[1],
          startIndex: match.index,
          endIndex: spanRegex.lastIndex
        });
      }

      // 处理连续span标签
      const processedMatches = [];
      let tempText = '';

      for (let i = 0; i < matches.length; i++) {
        // 检查当前span标签与下一个span标签是否连续（中间没有任何字符）
        if (i < matches.length - 1 &&
          matches[i].endIndex === matches[i+1].startIndex) {
          // 如果是连续span，拼接文本
          tempText += matches[i].text;
        } else {
          // 如果不是连续span，或者这是最后一个span
          if (tempText) {
            // 如果有正在拼接的连续span，完成拼接
            tempText += matches[i].text;
            processedMatches.push(tempText);
            tempText = '';
          } else {
            // 单个span标签
            processedMatches.push(matches[i].text);
          }
        }
      }
      // 去重处理
      return [...new Set(processedMatches)];
    },
    viewDetail (item, bookId, pageId, bookName,isLock=false) {

       if(isLock){
         this.$message({
           message: '您所在的机构尚未订阅此资源。请联系您的机构管理员。',
           type: 'warning'
         });
         return
       }
      // 搜索条件开始
      // const firstKeyword = this.search.keyword;
      // const type = this.newParam.searchType;
      // let tempqu = [];
      //   if (type == 2) {
      //     tempqu = this.advancedQuery;
      //     tempqu.unshift({ keyword: firstKeyword });
      //     let temptempqu = JSON.stringify(tempqu);
      //     query.advaList = temptempqu;
      //   }
      //   if (type == 3) {
      //     tempqu = this.neardQuery;
      //     tempqu.unshift({ keyword: firstKeyword });
      //     let temptempqu = JSON.stringify(tempqu);
      //     query.advaList = temptempqu;
      //   }

      let keyWordAll=this.extractSpanContents(item.text)
      console.log(keyWordAll)
      let search = JSON.stringify({ textType: this.newParam.textType, searchType: this.newParam.searchType, keyword: this.newParam.keyword, advancedQuery: this.advancedQuery, nearQuery: this.neardQuery, searchFilter: this.searchFilter })
      // let search = JSON.stringify(this.newParam)
      // 搜索条件结束
      const query = {
        keyWordAll:JSON.stringify({keyWordAll:keyWordAll}),
        bookId,
        bookName,
        pageId,
        //search,
        from:'sousuo'
        //juanNum: item.juanNum,
        //keywords: this.newParam.keyword
      }

      let routeData = this.$router.resolve({
        path: "/read",
        query,
      })
      // 在Vue组件中
      // let routeData = this.$router.push({ name: 'Read', params: { operStr: str } })

      window.open(routeData.href, "_blank")
    },
    // getSearchTreeChecked (item, type, keys) {
    //   const key = item.key
    //   let searchParams
    //   let paramKey
    //   if (keys) {
    //     searchParams = this[keys]
    //   } else {
    //     if (this.customRangeType == "category") {
    //       paramKey = this.customRangeType
    //     } else {
    //       paramKey = this.isAuth
    //     }
    //     searchParams = this.searchParamsList[paramKey]
    //   }

    //   if (item.nodeType === "book") {
    //     searchParams.bookIds = searchParams.bookIds || []
    //     let findIndex = searchParams.bookIds.findIndex((v) => v == key)
    //     if (findIndex > -1) {
    //       searchParams.bookIds.splice(findIndex, 1)
    //     } else {
    //       searchParams.bookIds.push(key)
    //     }
    //   }
    //   if (item.nodeType === "writer") {
    //     searchParams.writerIds = searchParams.writerIds || []
    //     let findIndex = searchParams.writerIds.findIndex((v) => v == key)
    //     if (findIndex > -1) {
    //       searchParams.writerIds.splice(findIndex, 1)
    //     } else {
    //       searchParams.writerIds.push(key)
    //     }
    //   }
    //   if (item.nodeType === "category") {
    //     searchParams.categoryIds = searchParams.categoryIds || []
    //     let findIndex = searchParams.categoryIds.findIndex((v) => v == key)
    //     if (findIndex > -1) {
    //       searchParams.categoryIds.splice(findIndex, 1)
    //     } else {
    //       searchParams.categoryIds.push(key)
    //     }
    //   }
    //   if (item.nodeType === "dynasty") {
    //     searchParams.dynastyIds = searchParams.dynastyIds || []
    //     let findIndex = searchParams.dynastyIds.findIndex((v) => v == key)
    //     if (findIndex > -1) {
    //       searchParams.dynastyIds.splice(findIndex, 1)
    //     } else {
    //       searchParams.dynastyIds.push(key)
    //     }
    //   }
    //   if (item.nodeType === "letter") {
    //     searchParams.writerInitials = searchParams.writerInitials || []
    //     let findIndex = searchParams.writerInitials.findIndex((v) => v == key)
    //     if (findIndex > -1) {
    //       searchParams.writerInitials.splice(findIndex, 1)
    //     } else {
    //       searchParams.writerInitials.push(key)
    //     }
    //   }
    //   if (!keys) {
    //     this.searchParamsList[paramKey] = searchParams
    //   }
    // },
    getCategory () {
      booksTree({
        parentId: "0",
        nodeType: "category",
        keyword: this.search.category,
      }).then((d) => {
        this.treeList.category = d.data
        this.isCategorySearch = !!this.search.category
      })
    },

    getPinyin () {
      booksTree({
        parentId: "0",
        nodeType: "letter",
        keyword: this.search.pinyin,
      }).then((d) => {
        this.treeList.pinyin = d.data
        this.isPinyinSearch = !!this.search.pinyin
      })
    },
    getDynasty () {
      booksTree({
        parentId: "0",
        nodeType: "dynasty",
        keyword: this.search.dynasty,
      }).then((d) => {
        this.treeList.dynasty = d.data
        this.isDynastySearch = !!this.search.dynasty
      })
    },
    newload () {
      this.newloading = true
      setTimeout(() => {
        // if (this.isSearching) {
        this.newParam.pageNum += 1
        this.postSearch()

        // } else {
        //   this.empSearchChange()

        // }
      }, 2000)
    },
    pageChange (val) {
      if((parseInt(val-1))===(this.newParam.pageNum)){
        this.newParam.pageNum = val
        this.postSearch(false,false,true)
      }else{
        this.newParam.pageNum = val
        this.postSearch()
      }

    },
    // 按钮查询
    clickSearch (isBtnSearch = false, isLeftTree = false) {
      // $event.stopPropagation();//阻止冒泡
      // 头部按钮搜索 更新左侧右侧
      // if (isBtnSearch) {
      //参数恢复初始值
      // searchResult.numArr[0].value
      let tempParam = {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        // keyword:'',
        type: 0,
        // searchType: "0",
        //sort: "0", //排序 0 正序 1倒序
        //sortType: 0, //排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
        categoryNames: [],
        //writerIds: "",
        // dynastyIds: "",
        dynastyNames: [],
        //writerInitials: "",
        bookIds: "",
        advaList: [],
        hitCountType: 0,
        // isBook: 0
      }
      // this.searchFilter = {
      //   writerIds: [],
      //   dynastyIds: [],
      // }
      // if (this.newParam.searchType == 3) {
      //   tempParam.searchType = '0'
      //   tempParam.isBook = 1
      // }
      this.numresult = 0
      this.numBookResult = 0

      this.newParam = { ...this.newParam, ...tempParam }
      if (this.newParam.searchType == 1) {
        this.newParam.advaList.forEach(item=>{
          return item.trim()
        })
        this.newParam.advaList = this.advancedQuery.filter((item) => {
          return item.keyword !== ""
        })
      }
      if (this.newParam.searchType == 2) {
        this.newParam.advaList.forEach(item=>{
          return item.trim()
        })
        this.newParam.advaList = this.neardQuery.filter((item) => {
          return item.keyword !== ""
        })
      }

      //搜索范围
      // if (this.rangeType == 2) {
      // if (this.newIsCheck) {
      // let checkedKeys = []
      // if (this.customRangeType == "category") {
      // checkedKeys = this.$refs.scopeTreeCat && this.$refs.scopeTreeCat.getCheckedKeys(true)
      // this.storageHistory(`category`, this.search.category)//输入框历史记录

      // } else {
      // checkedKeys =
      //   this.isAuth === "dynasty"
      //     ? this.$refs.scopeTreeWriterDynasty && this.$refs.scopeTreeWriterDynasty.getCheckedKeys(true)
      //     : this.$refs.scopeTreeWriter && this.$refs.scopeTreeWriter.getCheckedKeys(true)

      //输入框历史记录
      //   this.isAuth === "dynasty"
      //     ? this.storageHistory(`dynasty`, this.search.dynasty) : this.storageHistory(`pinyin`, this.search.pinyin)
      // }
      // if (checkedKeys) this.newParam.bookIds = checkedKeys.join(",")

      // }
      // this.clearSearchTree()
      // }
      // if (this.rangeType == "1") {
      //   this.newParam.bookIds = ""
      // }
      //模糊查询精确查询
      this.newParam.searchAccuracyType = this.searchAccuracyType ? 1 : 0
      // }
      //左侧树选择 更新右侧数据和列表
      // let handleFields = [
      //   "categoryNames",
      //   "bookReadingListIds",
      //   "dynastyNames",
      //   "writerIds"
      // ]
      let handleFields = [
        "bookReadingListIds"
      ]
      // ,
      // if (isLeftTree) {
      // console.log(this.searchFilter, 'tempSearchFilter')
      this.isSearchFilter = false
      // this.searchFilter.bookIds = this.$refs.treeList.getCheckedKeys(true)
      let tempSearchFilter = JSON.parse(JSON.stringify(this.searchFilter))
      handleFields.map((fields) => {
        if (tempSearchFilter[fields]) {
          tempSearchFilter[fields] = tempSearchFilter[fields].join()
        }
      })


      this.newParam = { ...this.newParam, ...tempSearchFilter }
      let textTypeBox={
        "0":"全部",
        "1":"正文",
        "2":"注释",
        "3":"专名词",
        "4":"作者",
        "5":"书名",
        "8":"书名词",
        "9":"地名词",
      }
      let typeAllBox={
        'or':'OR',
        'and':'AND',
        'not':'NOT',
      }
      this.newParam.keyword=this.newParam.keyword.trim()
      if (this.newParam.searchType == '0' ||this.newParam.searchType == '3'){
        if(this.newParam.keyword){
          this.keywordAll=this.newParam.keyword
        }else{
          this.$message({
            message: '请输入有效关键词',
            type: 'warning'
          });
          return
        }
      }else{
        if(this.newParam.keyword){
          this.keywordAll=`(${textTypeBox[this.newParam.textType]}=${this.newParam.keyword})`
        }else{
          if(this.newParam.advaList&&(this.newParam.advaList.length===0)){
            this.$message({
              message: '请输入有效关键词',
              type: 'warning'
            });
            return
          }
        }

      }

      //搜索框历史搜索
      if (this.newParam.advaList) {
        let keystr = ''
        if (this.newParam.searchType == 1) {
          keystr = 'advanced'
        } else if (this.newParam.searchType == 2) {
          keystr = 'neard'
        }
        this.newParam.advaList.forEach((item, index) => {
          this.keywordAll=`${this.keywordAll}${typeAllBox[item.type]}(${textTypeBox[item.textType]}=${item.keyword})`
          this.storageHistory(`${keystr}${index}`, item.keyword)
        })
      }
      if (this.newParam.keyword) {
        this.storageHistory('keyword', this.newParam.keyword)
      }

      this.searchResult.bookList = []
      this.newParam.pageNum = 1
      this.newParam.total = 0

      this.postSearch(isBtnSearch, isLeftTree)


    },
    // 最近操作
    addLatest (type) {
      const { keyword, advaList, searchType, sortType, sort, isInnerSearch, searchAccuracyType } = this.newParam
      let tempoper = {
        keyword, advaList, searchType, sortType, sort, isInnerSearch, searchAccuracyType
      }
      if (this.newParam.searchType == 1) {
        tempoper.advancedQuery = this.advancedQuery
      }
      if (this.newParam.searchType == 2) {
        tempoper.nearQuery = this.nearQuery
      }

      let param = {
        guestId: this.$getUUID(),
        operType: "search",
        operStr: JSON.stringify(tempoper)
      }
      // console.log(param, 'param')
      addLatest(
        param
      ).then((e) => {
        console.log(e, 'eee')
      })
    },
    // 查询
    postSearch (isBtnSearch = false, isLeftTree = false,isNext=false) {
      // this.isFanwei = false;
      // this.newloading = true
      this.description = "正在查詢 请等候"

      this.changestate = "全部展开"
      // if (!this.newParam.keyword) {
      //   return this.$message.warning("請輸入或選擇書名")
      // }
      this.loading = true
      this.isSearching = true
      // console.log(this.newParam, 'this.newParam')
      // this.isHaveLimits()
      // if (this.newParam.searchType != 2) { //near查詢左侧树在列表查詢后
      //   if (isBtnSearch) {
      //     this.searchResult.tree = []
      //     this.newParam.hitCountType = 0
      //     this.getSearchContent()
      //     this.searchFilter.type = "0"
      //   }
      //   if (isLeftTree) {
      //     this.newParam.hitCountType = 1 // 0 获取所有（左侧加右侧） 1只获取右侧  2获取初始树 数量
      //     this.getSearchContent()
      //     this.searchFilter.type = "0"
      //   }
      // }
      if(isNext&&(this.searchResult.bookList.length)){
        this.newParam.lastBookId=this.searchResult.bookList[this.searchResult.bookList.length-1].id
      }else{
        if(this.newParam.lastBookId){
          delete this.newParam.lastBookId
        }
      }
      this.newParam.isShowAll=!this.limitChose
      essearch(this.newParam).then(
        (data) => {
          // this.showmenu = false
          // console.log(data, 'dsfdata')
          if (data.code == 200
          ) {
            if (data.data.code == 500) {
              this.loading = false
              this.newloading = false
              return this.$message.warning(data.data.msg)

            }
            // this.catalogIdList = data.data.catalogIdList
            //this.newParam.numResultList = data.data.numResultList  //numResultList搜索返回，作为获取数量参数
            this.keywordStr = data.data.keywordStr
            data.data.bookList.forEach((bookListItem,bookListItemIndex)=>{
              if(data.data.bookList[bookListItemIndex].bookJuanList.length>0){
                data.data.bookList[bookListItemIndex].bookJuanList.forEach((bookJuanListItem,bookJuanListItemIndex)=>{
                  if(data.data.bookList[bookListItemIndex].bookJuanList[bookJuanListItemIndex].bookPageList.length>3){
                    data.data.bookList[bookListItemIndex].bookJuanList[bookJuanListItemIndex].flag=true
                  }else{
                    data.data.bookList[bookListItemIndex].bookJuanList[bookJuanListItemIndex].flag=false
                  }
                })
              }

            })
            let tempBookList = data.data.bookList
            // let tempnumResult = data.data.numResultList
            this.numresult = data.data.totalNum
            this.numBookResult = data.data.bookTotalNum

            this.newParam.total = data.data.bookTotalNum

            this.loading = false
            this.newloading = false
            this.isVisiableCustomRange = false
            // if (this.newParam.searchType == 2) { //near查詢左侧树在列表查詢后
            // if (isBtnSearch) {
            // this.searchResult.tree = []
            this.newParam.hitCountType = 0
            //this.getSearchContent()
            this.searchFilter.type = "0"
            // }
            // if (isLeftTree) {
            //   this.newParam.hitCountType = 1 // 0 获取所有（左侧加右侧） 1只获取右侧  2获取初始树 数量
            //   this.getSearchContent()
            //   this.searchFilter.type = "0"
            // }
            // }

            //新增4/6拼接作者等
            // tempBookList.forEach((item) => {
            //   item.writerarr = item.writerList.reduce(function (r, a) {
            //     r[a.writerRole] = r[a.writerRole] || []
            //     r[a.writerRole].push(a)
            //     return r
            //   }, Object.create(null))
            // })
            /*tempBookList.forEach((tempBookListItem,tempBookListItemIndex)=>{
              //tempBookList[tempBookListItemIndex].bookJuanListBox=[]
              if(tempBookListItem.bookJuanList.length>0){
                for(let bookJuanListIndex=0;bookJuanListIndex<tempBookListItem.bookJuanList.length;bookJuanListIndex++){
                  if(tempBookListItem.bookJuanList[bookJuanListIndex].bookPageList.length===0){
                    tempBookListItem.bookJuanList.splice(bookJuanListIndex,1)
                    bookJuanListIndex--
                  }
                }
              }
              /!*if(tempBookListItem.bookJuanList[0].length<3){

              }*!/
              //tempBookList[tempBookListItemIndex].bookJuanListBox=[tempBookListItem.bookJuanList[0]]
            })*/
            for(let tempBookListItemIndex=0;tempBookListItemIndex<tempBookList.length;tempBookListItemIndex++){
              let tempBookListItem=tempBookList[tempBookListItemIndex]
              if(tempBookListItem.bookJuanList.length>0){
                for(let bookJuanListIndex=0;bookJuanListIndex<tempBookListItem.bookJuanList.length;bookJuanListIndex++){
                  if(tempBookListItem.bookJuanList[bookJuanListIndex].bookPageList.length===0){
                    tempBookListItem.bookJuanList.splice(bookJuanListIndex,1)
                    bookJuanListIndex--
                  }
                }
              }
              /*if((this.newParam.searchType!=='3')&&tempBookList[tempBookListItemIndex].bookJuanList.length===0){
                tempBookList.splice(tempBookListItemIndex,1)
                tempBookListItemIndex--
              }else{
                let itemData=tempBookList[tempBookListItemIndex].bookJuanList
                for(let itemDataIndex=0;itemDataIndex<itemData.length;itemDataIndex++){
                  if(itemDataIndex!==0){
                    itemData[0].bookPageList=itemData[0].bookPageList.concat(itemData[itemDataIndex].bookPageList)
                    itemData.splice(itemDataIndex,1)
                    itemDataIndex--
                  }
                }
              }*/
              let itemData=tempBookList[tempBookListItemIndex].bookJuanList
              for(let itemDataIndex=0;itemDataIndex<itemData.length;itemDataIndex++){
                if(itemDataIndex!==0){
                  itemData[0].bookPageList=itemData[0].bookPageList.concat(itemData[itemDataIndex].bookPageList)
                  itemData.splice(itemDataIndex,1)
                  itemDataIndex--
                }
              }
            }
            console.log(tempBookList)

            this.searchResult.total = data.data.bookTotalNum
            this.searchResult.bookList = tempBookList
            if (tempBookList.length == 0) { this.description = "檢索無結果，請換個關鍵詞檢索" } else if (tempBookList.length == 0 && this.searchResult.numArr[0].value != 0) { this.description = "符合條件的結果數據量過於龐大，不再展示,敬請諒解。" }

            // this.searchResult.bookList = [
            //   ...this.searchResult.bookList,
            //   ...tempBookList,
            // ]
            // tempnumResult.forEach((item) => {

            //   this.numresult += item.mainNum
            // })

            // this.searchResult.bookList = tempBookList;
            this.activeName =
              this.searchFilter.type == 3
                ? ""
                : this.searchResult.bookList.map((item) => {
                  this.activeListName[item.id] =
                    item.bookJuanList[0] && item.bookJuanList[0].juanName
                  return item.bookName
                })

            if (localStorage.token && this.newParam.pageNum == 1) { this.addLatest(2) }
            this.$forceUpdate()
          }
          this.loading = false
          // this.hightLighyt();
          this.newloading = false

        },
        () => (this.loading = false)
      )
      // setTimeout(() => {
      //   this.isShow = false
      //   this.chaoShow = false
      // }, 1000)
      // window.scrollTo(0, 0)
    },

    getCategoryNodeData (que) {
      this.emptyText = "查詢中..."
      //   parentId: "0",
      //   nodeType: "category",
      // }).then((data) => {
      // let isOnlyPermit = this.newParam.isOnlyPermit
      // this.emptyText = "查詢中..."
      // getHitCount({
      //   hitCountType: 2,
      // }).then((data) => {
      //   this.searchResult.tree = data.data.tree

      //   this.$forceUpdate()
      //   if (this.isSearching) {
      //     this.emptyText = "暫無數據"
      //     this.$nextTick(
      //       () =>

      //         this.$refs.treeList && this.$refs.treeList.filter(this.isSimple)
      //     )
      //   } else {
      //     this.emptyText = "暫無授權文獻"
      //     this.$nextTick(
      //       () =>
      //         this.$refs.defaultSearchTree &&
      //         this.$refs.defaultSearchTree.filter(this.isSimple)
      //     )
      //   }

      // })
      // this.emptyText = "查詢中..."
      newGetCategoryNode(que).then((data) => {
        if (data.data && data.data.length == 0) {
          this.emptyText = "暫無數據"
        }

        this.catalist = data.data
        // console.log(this.catalist, 'this.catalist')

        // this.$forceUpdate()
        // if (this.isSearching) {
        //   this.emptyText = "暫無數據"
        //   this.$nextTick(
        //     () =>

        //       this.$refs.treeList && this.$refs.treeList.filter(this.isSimple)
        //   )
        // } else {
        //   this.emptyText = "暫無授權文獻"
        //   this.$nextTick(
        //     () =>
        //       this.$refs.defaultSearchTree &&
        //       this.$refs.defaultSearchTree.filter(this.isSimple)
        //   )
        // }

      })
    },
    getDynastyListNew () {
      let que = { keyword: this.dynasty }
      getDynastyListNew(que).then((data) => {
        if (data.data && data.data.length == 0) {
          this.emptyText = "暫無數據"
        }
        this.dynastylist = data.data

      })

    },

    getSearchContent (isRight = true) {
      this.emptyText = "查詢中..."
      getHitCount(this.newParam).then((data) => {
        if (this.newParam.hitCountType == 0) {
          // this.searchResult.dynastyList = data.data.dynastyList
          // this.searchResult.writerList = data.data.writerList
          // this.searchResult.tree = data.data.tree

          // this.bookNum = data.data.bookNum
          // this.totalNum = data.data.totalNum
        }
        this.emptyText = "没有符合条件的结果"
        this.$forceUpdate()
        this.$nextTick(() => {
          this.$refs.treeList && this.$refs.treeList.filter(this.isSimple)
        })
        // if (isRight) {
        this.searchResult.numArr = [
          {
            name: "全部",
            value: data.data.totalNum,
            type: "0",
          },
          {
            name: "正文",
            value: data.data.mainNum,
            type: "1",
          },
          {
            name: "校記",
            value: data.data.noteNum,
            type: "2",
          },
          {
            name: "專名",
            value: 0,
            type: "10",
          },
          // {
          //   name: "書名",
          //   value: data.data.bookNum,
          //   type: "3",
          // },
        ]
        // }

        // this.searchResult.dynastyList = data.data;
        // this.$forceUpdate();
      })
    },
    setRangeType (idx) {
      if (idx === 11) {
        if (this.newIsCheck) {
          this.isVisiableCustomRange = !this.isVisiableCustomRange
        } else {
          this.xdwenxian = ''
        }
      } else if (idx === 2) {
        // this.isFanwei = true;
        // this.isVisiableCustomRange = true;
        this.isVisiableCustomRange = !this.isVisiableCustomRange
        this.getWxFanWei()
      } else {
        // this.isFanwei = false;
        this.isVisiableCustomRange = false
        this.clearSearchTree()
      }
      // this.rangeType = this.rangeType === idx ? "" : idx;
      this.rangeType = idx
    },
    getWxFanWei () {
      let arra = []
      let a = this.$refs.scopeTreeCat.getCheckedNodes(true)
      let b = this.$refs.scopeTreeWriterDynasty.getCheckedNodes(true)
      let c = this.$refs.scopeTreeWriter.getCheckedNodes(true)

      arra = [...a, ...b, ...c]

      let xdwenxianarr = arra.map((item) => {
        return item.name
      })

      this.xdwenxian = xdwenxianarr.join('，')
    },
    setSearchFilter () {
      // const { dynastyIds, writerIds } = this.searchFilter
      // this.isSearchFilter =
      //   (dynastyIds && dynastyIds.length) ||
      //   (writerIds && writerIds.length) ||
      let ids = this.$refs.treeList.getCheckedKeys(true)
      this.searchFilter.dynastyNames = ids
      // this.$forceUpdate()
      this.clickSearch()
    },
    typeSearch (type) {
      //  this.searchFilter['type'] = type;

      this.newParam.type = type == "3" ? 0 : type
      // this.newParam.type = type;
      this.searchFilter.type = type
      this.$forceUpdate()
      if (type != 3) this.clickSearch(false, false)
    },
    getClientInfo (e, ele) {
      this.dragEle = ele
      this.rightOpera = {
        width: this.$refs[ele].$el
          ? this.$refs[ele].$el.clientWidth
          : this.$refs[ele].clientWidth,
        startX: e.clientX,
        isMouseDown: true,
      }
    },
    moveClient (e, ele) {
      if (!this.rightOpera.isMouseDown) {
        return
      }
      e.stopPropagation()
      e.preventDefault()
      const { startX } = this.rightOpera
      let offsetWidth = e.clientX - startX
      if (this.dragEle === "leftDragCate") {
        offsetWidth = startX - e.clientX
      }

      let el = this.$refs[this.dragEle].$el || this.$refs[this.dragEle]
      el.style.width = this.rightOpera.width - offsetWidth + "px"
      this.$forceUpdate()
    },
    mouseUp () {
      this.rightOpera = {
        isMouseDown: false,
      }
    },
  },
  beforeDestroy () {
    this.$bus.$off("changeShow")

    this.$bus.$off('reloadSearch')
  }
};
</script>

<style lang="less" scoped>
@primary-color: #f4f0e8;
@first-color: #2c7e8d;
@secont-color: #666666;
@three-color: #999999;
@four-color: #333333;
@PingFang-SC-Medium: PingFang-SC-Medium;
@PingFangSC-Regular: PingFangSC-Regular;
@PingFang-SC-Bold: PingFang-SC-Bold;
@PingFang-SC-ExtraLight: PingFang-SC-ExtraLight;
/deep/.el-pagination.is-background .el-pager li:last-child:not(.active) {
  display: none !important;
}
/deep/.el-pagination.is-background .btn-prev + .el-pager li:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
/deep/.el-tree {
  background: none;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #E9B63E;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: white;
}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #DCDFE6;
}
// /deep/.el-pagination.is-background .btn-next,
// /deep/.el-pagination.is-background .btn-prev,
// /deep/.el-pagination.is-background .el-pager li {
//   color: @first-color;
// }
/deep/.el-pagination.is-background .btn-next:hover,
/deep/.el-pagination.is-background .btn-prev:hover,
/deep/.el-pagination.is-background .el-pager li:hover {
  background: #E9B63E;
}
/deep/.el-button--primary {
  background: #DBB054;
  border-color: #fff;
}
// /deep/.el-checkbox__input .is-checked .el-checkbox__inner,
// /deep/.el-checkbox__input .is-indeterminate .el-checkbox__inner {
//   background: #2c7e8d;
//   border-color: #2c7e8d;
// }
::-webkit-scrollbar{
  width: 5px;
}
.zuozhe {
  /deep/.el-checkbox__label {
    max-width: 109px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
}
.restext {
  font-family: @PingFang-SC-ExtraLight;
  font-size: 12px;
  color: @secont-color;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
  span {
    font-family: @PingFang-SC-Bold;
    font-weight: 700;
  }
}
.booksss {
  display: inline-block;
  font-family: PingFang-SC-Medium;
  font-size: 14px;
  color: #573E0D;
  letter-spacing: 0;
  line-height: 14px;
  font-weight: 400;
  margin-left: 20px;
  cursor: pointer;
}
/deep/.el-input-group__append {
  // transform: scaleX(-1) scaleY(-1);
  background: @first-color;
  border-radius: 0px 4px 4px 0px;
}
.mengban {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
}
@import url(../assets/iconfont.css);
/deep/.el-input-group__prepend{
  background-color: #fff;
}
.inputNumber /deep/.el-input-group__prepend{
  padding: 0 0 0 20px;
}
.inputNumber .onlyNumber /deep/.el-input__inner{
  border-right: none;
  border-top:none;
  border-bottom: none;
  border-radius: 0;
}
/deep/.el-card {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  border: none;
}
/deep/.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}
/deep/.el-input-number.is-controls-right .el-input__inner {
  padding-left: 10px;
}
/deep/.el-autocomplete {
  width: 100%;
}
.checkboxstyle {
  margin-left: 20px;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #E9B63E;
}
/deep/ .el-checkbox__label{
  color: #2B2B2B;
}
.xinghao {
  // color: #3366cc;
  color: #e60012;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #E9B63E;
  border-color: #E9B63E;
}
/deep/.el-input .is-active .el-input__inner,
/deep/.el-input__inner:focus {
  border-color: #E9B63E;
}
/deep/.el-checkbox__input .is-focus .el-checkbox__inner,
/deep/.el-checkbox__inner:hover {
  border-color: #E9B63E;
}
/deep/ .el-dialog {
  width: 80%;
}
/deep/.el-dialog__body {
  padding: 0 20px 30px;
}

.heitani {
  transition: height 0.3s linear;
  // will-change: height;
  height: 100%;
  .itemStyle {

    padding: 10px 10px 2px 10px;
    margin-bottom: 15px;
    //border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
  }
  .itemStyle:hover {
    background-color: #FEFBF4;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    border-radius: 4px;
    /deep/.el-collapse-item__header,/deep/.el-collapse-item__wrap{
      background-color: #FEFBF4;
    }
  }

}
.margin-ri {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 1.15rem;
  margin-top: 0.5rem;
}
.sback {
  width: 100%;
  height: 88px;
  background: url("/static/homenew/sback.png") no-repeat;
  background-size: 100% 88px;
}
.topbottom {
  width: 100%;
  height: 20px;
  text-align: center;
  // line-height: 2rem;
  // position:absolute;
  // opacity: 0;
  position: relative;
  img {
    position: absolute;
    cursor: pointer;
    height: 12px;
    //  animation:mymove 2s infinite;
  }
  .totop {
    animation: mymove 2s infinite;
  }
  .tobottom {
    animation: mymovetwo 2s infinite;
  }
}
@keyframes mymove {
  from {
    bottom: 0px;
    opacity: 100;
  }
  to {
    bottom: 5px;
    opacity: 0;
  }
}
@keyframes mymovetwo {
  from {
    top: 0px;
    opacity: 0;
  }
  to {
    top: 5px;
    opacity: 100;
  }
}

// /deep/ .el-input-group__prepend{
//   padding-left:10px;
//   padding-right: 0px;
// }
// /deep/ .el-input__inner{
//   padding: 0 20px;
// }
// /deep/ .el-input{
//   width: 90%;
// }
// /deep/.icon-menu{
//   // color:#1b1b1b
//   cursor: pointer;
// }

.submit-btn {
  width: 80px;
  height: 39px;
  // margin-left: 2rem;
  font-size: 1rem;
  padding: 8px 20px 8px 20px;
  color: #fff;
  // background-color: #3366cc;
  // border-color: #3366cc;
  // transform: scaleX(-1) scaleY(-1);
  background: #795636;
  border-radius: 0px 4px 4px 0px;
  border: none;
}
.submit-btn :hover,
.submit-btn :focus {
  background: var(--el-button-hover-color);
  border-color: var(--el-button-hover-color);
  color: var(--el-button-font-color);
}
.searchA {
  background: var(--el-button-hover-color);
  border-color: var(--el-button-hover-color);
  font-size: 1rem;
  padding: 8px 16px 6px 16px;
}
.cover {
  display: flex;
   background: #f4f0e8;
  //background: url("/static/homenew/sback.png") no-repeat;
  //background-size: 100% 80%;
  .btn {
    padding: 0.3rem 0.9rem;
    background: #e6e6e6;
    border-radius: 1rem;
    font-size: 0.8421rem;
    text-align: center;
    cursor: pointer;
    color: #fff;
    // margin-right: 1.15rem;
    background: #795636;
    border: 1px solid rgba(44, 126, 141, 0.4);
    border-radius: 4px 0px 0px 4px;

    font-family: @PingFang-SC-Bold;
    font-size: 14px;
    color: #fff;
    letter-spacing: 0;
    text-align: center;
    line-height: 14px;
    font-weight: 700;

    &:not(disabled=disabled):hover {
      background: #3366cc;
      color: #fff;
    }
    &.active {
      background: #3366cc;
      color: #fff;
    }
    &[disabled="disabled"] {
      cursor: not-allowed;
    }

    img {
      width: 0.94rem;
    }
  }
  .margin {
    margin: 0.65rem 0;
  }
  .marginNew {
    margin: 1.2rem 0 0.65rem;
  }
  .search-box {
    // padding: 2rem 0 1rem;
    // box-shadow: 0rem 0rem 1rem 0rem rgba(112, 112, 112, 0.2);
    // background: #f0f8ff;
    // height: 80px;
    // line-height: 80px;
    padding-top: 20px;
    > .content {
      width: 86rem;
      margin: 0 auto;
      min-width: 1000px;
      max-width: 100%;
    }
    .left-input-box {
      width: 556px;
      /deep/ .el-input-group__prepend {
        width: 80px;
      }
      // /deep/ .input-select {
      // display: block;
      // margin-bottom: 1rem;
      // > .el-input__inner {
      //   width: 27rem;
      // }
      // &:first-child .el-input__inner{
      //   width: 31.2rem;
      // }

      // &.input-select-label {
      //   .el-input__inner {
      //     // width: 23.5rem;
      //     text-align: center;
      //   }
      // }
      // }

      .after {
        width: 1.15rem;
        height: 1.15rem;
        cursor: pointer;
      }
    }

    .search-range {
      width: 36rem;
      // height: 7.74rem;
      height: 1.04rem;
      margin-top: 8px;
      // background: #ffffff;
      // border: 0.1rem solid #c9c9c9;
      // border-radius: 0.4rem;
      // padding: 0.52rem 0.78rem;
      color: #3366cc;
      font-size: 16px;
      cursor: pointer;
      /deep/ .el-tree {
        height: 20rem;
        overflow-y: auto;
      }
      /deep/ .el-dialog {
        width: 680px;
      }
      .zdbox {
        display: flex;
        flex-direction: column;
      }
      .zdxuanze {
        display: flex;
        margin-top: 8px;
        margin-left: 24px;
      }
      .weixuanze {
        font-size: 12px;
        color: #3366cc;
        margin-top: 8px;
        padding-left: 24px;
        i {
          font-style: normal;
          color: #606266;
        }
      }
      .zidingyi {
        display: block;
        width: 150px;
      }
      // .xdwenxianborder {
      //   border: 1px solid #eee;
      //   border-radius: 3px;
      //
      //   margin-top: 0px;
      //   padding: 8px;

      // }
      .kuohao {
        font-size: 30px;
      }
      .xdwenxian {
        display: block;
        width: 30rem;
        margin: 0 5px;
        // height: 2rem;
        // padding: 5px;

        // width: 100%;
        // display: flex;
        font-size: 12px;
        line-height: 16px;

        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .select-range {
        padding: 1.77rem 3.75rem;

        /deep/ .el-checkbox__label {
          color: #3366cc;
        }
        i {
          cursor: pointer;
        }
      }

      /deep/ .el-tree-node {
        font-size: 14px;
      }
      /deep/ .el-tree-node .el-tree-node .el-tree-node {
        white-space: pre-wrap;
      }
      /deep/ .el-tree-node .el-tree-node .el-tree-node .el-tree-node__content {
        // font-size: .8947rem;
        height: auto;
        line-height: 26px;
        span:nth-child(3) {
          display: inline-block;
          box-sizing: border-box;
          padding-right: 42px;
          width: 100%;
          // flex:1
          // line-height: 20px;
        }
      }
    }
  }
  .borderline {
    height: 100%;
    width: 100%;
    overflow-y: auto;
    // border-bottom: 0.1rem solid #ccc;
    // border-top:0.1rem solid #ccc;
    .borderlinecon {
      width: 80%;
      // height: 10px;
      margin: 0 auto;
      // border-top: 1px solid #ccc;
    }
    // .topline{

    // }
    // .bottomline{
    //   border-bottom:1px solid #ccc;
    // }
  }

  .content-box {
    // display: flex;
    display: -webkit-box;
    flex: 1;
    flex-grow: 1;
    overflow: auto;
    padding: 0 10px;
    // margin-top: 1rem;
    .open-all-btn {
      // margin-left: 24px;
      width: 86px;
      height: 27px;
      line-height: 27px;
      cursor: pointer;
      // background: @first-color;
      // border: 1px solid rgba(44, 126, 141, 0.4);
      // border-radius: 4px 0px 0px 4px;
      // transform: scaleX(-1) scaleY(-1);
      background: #fff;
      border: 1px solid #795636;
      border-radius: 4px;
      span {
        height: 24px;
        line-height: 20px;
      }
      font-family: @PingFangSC-Regular;
      font-size: 12px;
      color: #795636;
      letter-spacing: 0;
      text-align: center;
      //line-height: 12px;
      font-weight: 400;
    }
    .tree-list {
      // padding: 24px;
      margin-right: 16px;
      /*padding-left: 15px;
      padding-right: 10px;*/
      padding: 24px;
      padding-right: 0;
      width: 324px;
      // width: 16.7%;
      position: relative;
      // padding-bottom: 50px;
      // background: #fff;
      background: #FEFBF4;
      border-radius: 4px;
      // overflow: auto;
      // overflow-y: scroll;
      overflow: hidden;
      .el-input {
        width: 180px;
      }
      .drag-box {
        left: initial;
        right: 0;
      }
      .simplestyle {
        // width: 290px;
        margin: 10px auto 5px;
      }
      .treescroll {
        height: 100%;
        // overflow-y: hidden;
        // overflow-x: hidden;
        padding-right: 5px;
        padding-bottom: 50px;
        // .simplestyle {
        //   width: 290px;
        //   margin-top: 10px;
        // }
        .tree {
          height: 33%;
          .treeitem {
            height: 70%;
            overflow-y: auto;
            overflow-x: hidden;
          }
        }
      }
      img {
        width: 1.56rem;
      }
      .tree {
        margin: 0;
        font-size: 18px;
        color: #1b1b1b;
        padding: 12px 0;
        //border-bottom: 0.1rem solid #ccc;
        .padding-left {
          padding-left: 1.6rem;
        }
        .left-width {
          width: 290px;
        }
        .titles {
          display: flex;
          margin-bottom: 15px;
          text-align: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #573E0D;
        }
        .right-icon {
          font-size: 1.2rem;
          color: #9999;
          cursor: pointer;
        }
      }
      .treeTittle{
         display: flex;
        justify-content: space-between;
        .tittleName{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #573E0D;
        }
      }
    }
    .select-content {
      flex: 3;
      // background: #f5f9ff;
      padding: 1.4rem;
      background: #fff;
      border-radius: 4px;
      .head-condition {
        padding: 0 1.4rem 1rem;
        .label {
          font-size: 1.04rem;
          // font-family: FZShuSong-Z01T;
          // font-weight: bold;
          color: #1b1b1b;
        }
      }
      .head-title {
        // color: #3366cc;
        // font-size: 1.2632rem;
        flex: 1;
        flex-grow: 1;

        font-family: @PingFang-SC-Medium;
        font-size: 16px;
        color: #002f38;
        letter-spacing: 0;
        line-height: 16px;
        font-weight: 500;

        // 原来列表的箭头不能控制传参 使用该icon模拟
        i {
          margin-top: 1rem;
          font-size: 13px;
          margin-right: 8px;
          opacity: 0;
        }
        .flagImg{
          opacity: 1;
          font-size: 17px;
          margin-right: 5px;
        }
      }
      .book-number {
        color: #3366cc;
        font-size: 1.15rem;

        padding-right: 0.36rem;
      }
      .sm-title {
        // color: #3366cc;
        // font-size: 0.73rem;
        font-family: @PingFang-SC-Medium;
        font-size: 12px;
        color: #573E0D;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 500;
      }
      .juan-title {
        font-size: 0.94rem;

        font-weight: bold;
        color: #3366cc;
        font-family: @PingFang-SC-Medium;
        font-size: 12px;
        color: @first-color;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 500;
        // margin-top:.94rem;
        i {
          cursor: pointer;
        }
        .num {
          font-size: 0.73rem;
          padding-left: 0.63rem;
        }
      }

      .search-content-box {
        width: 90%;
        color: #313131;
        font-size: 0.94rem;
        // box-sizing: border-box;
        margin-bottom: 0.8rem;
        line-height: 2;

        > .search-info-box {
          // border-bottom: 0.1rem solid #999;
          // padding-bottom: 0.42rem;
          // margin-bottom: 0.42rem;
        }
        .search-info {
          padding-right: 1.88rem;
          // font-size: 0.83rem;
          font-family: @PingFangSC-Regular;
          font-size: 12px;
          color: @three-color;

          letter-spacing: 0;
          line-height: 3;
          font-weight: 400;

          .icon {
            width: 1.15rem;
            margin-right: 0.3rem;
            // cursor: pointer;
          }
          ul {
            display: flex;
          }
          i {
            font-style: normal;
            opacity: 1;
            margin: 0;
            font-size: 12px;
          }
        }
        .content {
          flex: 1;
          flex-grow: 1;
          // font-size: 0.94rem;

          // color: #313131;
          // line-height: 2.3rem;
          overflow: hidden;
          // white-space: nowrap;
          text-overflow: ellipsis;
          font-family: @PingFang-SC-ExtraLight;
          font-size: 14px;
          color: @four-color;
          letter-spacing: 0;
          // line-height: 18px;
          font-weight: 400;
          margin-top: 8px;

          &.in-title {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .book-icon {
          width: 1.15rem;
          height: 1.15rem;
          margin-left: 1rem;
          cursor: pointer;
        }
        .search-content {
          // margin-top: 0.52rem;
          width: 100%;
          &.list {
            // cursor: pointer;
          }
          .sort {
            font-family: @PingFang-SC-ExtraLight;
            font-size: 14px;

            // color: #e60012;
            color: @four-color;
            // padding-right: 1rem;
            margin-top: 8px;
          }
        }
      }
    }
  }

  .search-icon {
    font-size: 18px;
    display: flex;
    height: 100%;
    align-items: center;
    cursor: pointer;
  }
}
.fixed-btn {
  position: absolute;
  left: 0;
  bottom: 0;
}
.span-ellipsis {
  width: 100%;
  font-size: 14px;
  //overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.second-btn-box {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  padding: 10px 24px;
  // background: #fff;
  // border-top: 0.1rem solid #ccc;
  position: absolute;
  bottom: 0;
  left: 0;
  background: var(--el-button-hover-color);
  border-color: var(--el-button-hover-color);
}
/deep/ .el-collapse-item__header {
  height: auto;
  align-items: flex-start;
  position: relative;
  line-height: 2rem;
  border-bottom: none;

  .el-collapse-item__arrow {
    display: none;
    margin-top: 1rem;
    position: absolute;
    right: 0;
    pointer-events: none;
  }
}
/deep/ .el-collapse {
  // border-bottom-color: #ccc;
  border-top: none;
}

/deep/ .el-collapse-item__wrap {
  border-bottom: none;
}
/deep/ .el-collapse-item {
  border-bottom: 1px solid #EDE7D8 ;
  position: relative;
}
/deep/ .el-collapse-item__content {
  padding-bottom: 5px;
  line-height: 1.8rem;
}
/deep/ .cursorauto {
  cursor: auto;
}
/deep/ .cursorpointer {
  cursor: pointer;
  color: #573E0D;
}
</style>



// WEBPACK FOOTER //
// src/view/search.vue